import React, { useCallback, useEffect, useState } from 'react';
import { kararUygula, kararGeriAl, aiOneriler, oneriDetay, kararOnayla, kararReddet,
         yapiKampanyalar, yapiSetler, isEmriAc, isEmriIptal,
         icerikKararaGore, briefUret, icerikParca, icerikMedyaTuru,
         icerikUretimBilgisi, reklamApiKok,
         medyaUret, sesUret, finalUret, sesListe, cerceveKaydet, icerikPerformans,
         icerikYayinOnizleme, icerikYayinla, icerikYayiniDurdur, icerikOnizlemeTazele,
         icerikYayinDurumu, icerikYayiniBaslat, icerikOnizlemeler,
         gozdenGecirEylem, icerikDetay, icerikBriefIptal,
         kendiGorselimYukle, kendiGorselimIptal, icerikSablonlar } from '../../services/reklamApi';

// Reklam Yönetimi'nin üçüncü alt sekmesi — kullanıcı talebi: 2026-08-16. Sistemin ürettiği
// TÜM öneriler burada toplanır; özet listeden bir öneri açılınca pop-up'ta ayrıntısı görünür,
// kabul veya reddedilir.
//
// "YENİ REKLAM İÇERİĞİ" kategorisi ayrıca bir teslim/geri alma kanalıdır (kullanıcı akışı):
//   sistem → brief → onay → ÜRET (TopView + ElevenLabs + Creatomate şablonu) → final dosya
//   → YAYINLA. Canva adımı 2026-08-19'da tamamen kalktı, elle dosya hazırlanmıyor.
export default function AiOneriler() {
  const [durum, setDurum] = useState('yukleniyor');
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState('');
  const [secili, setSecili] = useState(null);
  // Bütçe uygulaması — kullanıcı rakamı değiştirebilir, son söz onda (2026-08-18).
  const [butce, setButce] = useState('');
  const [uygulamaDurumu, setUygulamaDurumu] = useState('');
  // Faz 3 — icerik uretim dongusu (2026-08-19)
  const [icerik, setIcerik] = useState(null);
  const [icerikDurum, setIcerikDurum] = useState('');
  const [notlar, setNotlar] = useState({});      // parca -> kullanici notu
  const [duzenlenen, setDuzenlenen] = useState({}); // parca -> kullanicinin kendi metni
  const [uretimBilgi, setUretimBilgi] = useState(null);  // hangi model, kalan kredi
  // ÜÇ AŞAMALI ÜRETİM (kullanıcı tasarımı: 2026-08-25): hangi aşama sürüyor + kaç saniyedir.
  const [asamaDurum, setAsamaDurum] = useState({ asama: null, sn: 0 });
  const [sesler, setSesler] = useState([]);        // Şablonlar ekranından yönetilen sesler
  const [seciliSes, setSeciliSes] = useState('');
  const [yayinOnizleme, setYayinOnizleme] = useState(null);
  const [yayinlaniyor, setYayinlaniyor] = useState(false);
  const [seciliSet, setSeciliSet] = useState(null);   // hedef set belli degilse kullanici secer
  const [yayinDurumu, setYayinDurumu] = useState(null);   // Meta'dan okunan gercek durum
  const [onizlemeler, setOnizlemeler] = useState([]);     // gomulebilir reklam onizlemeleri
  const [seciliYerlesim, setSeciliYerlesim] = useState(null);
  const [videoKaynak, setVideoKaynak] = useState(null);   // resim | video
  const [acikParca, setAcikParca] = useState({});          // onaylanmış ama tekrar açılan parçalar
  const [briefTur, setBriefTur] = useState(null);
  // Hasta/fizyoterapist çifti (kullanıcı talebi: 2026-08-25). Boş = kararı Claude verir.
  const [briefCinsiyet, setBriefCinsiyet] = useState('');
  // ANA FİKİR (kullanıcı talebi: 2026-08-25): brief yazılmadan önce çizilen çerçeve.
  const [anaFikir, setAnaFikir] = useState('');
  // Brief üretildikten SONRA da çerçeve değiştirilebilsin (kullanıcı talebi: 2026-08-25):
  // eldeki içerikte cinsiyeti not kutusuna elle yazmak zorunda kalınıyordu.
  const [cerceveDurum, setCerceveDurum] = useState('');
  // PERFORMANS RAPORU (kullanıcı talebi: 2026-08-31): "yaptığım işe yaradı mı?"
  const [rapor, setRapor] = useState(null);
  const [raporYukleniyor, setRaporYukleniyor] = useState(false);
  const [raporHata, setRaporHata] = useState('');
  // Şablon tercihi (kullanıcı talebi: 2026-08-24). Boş bırakılırsa sistem uygunlar
  // arasından rastgele seçer; seçilirse brief o şablonun kurallarına göre yazılır.
  const [sablonlar, setSablonlar] = useState([]);
  const [seciliSablon, setSeciliSablon] = useState('');
  // Hangi parça şu an işleniyor — buton kendi kartında meşgul görünsün diye
  // (kullanıcı: "Yeniden oluştur hiçbir şey yapmıyor", 2026-08-20: aslında yapıyordu ama
  // 20-40 saniyelik bekleme sırasında kartta hiçbir işaret yoktu).
  // Hangi parça işleniyor ve hangi eylemle — kart kendi içinde meşgul görünsün diye.
  const [islenenParca, setIslenenParca] = useState(null);
  const [islenenEylem, setIslenenEylem] = useState(null);
  const [gorselYukleniyor, setGorselYukleniyor] = useState(false);   // kendi görselini yükleme
  const [islemde, setIslemde] = useState(false);
  // Varsayilan 'Bekliyor' degil (2026-10-02): is emri ancak KABUL EDILINCE olusur.
  //
  // ANAHTAR 'KabulEdildi' (2026-10-06). Sunucuda bu anahtar "Durum=Onaylandi VE
  // UygulanmaZamani NULL" demek. Duz 'Onaylandi' gondermek, sunucunun varsayilan
  // dalina dusup yayinlanmis is emirlerini de "Bekleyen is emri"nde birakiyordu
  // (kullanici: "ustteki UYGULANDI icinde olmasi gerekmez miydi, onu yaptim ben").
  const [filtre, setFiltre] = useState('KabulEdildi');

  // + KREATİF YARAT (kullanıcı talebi: 2026-10-02) — "hangi kampanyanın hangi setinin içinde
  // reklam açacağımı sorsun ben seçeyim ve iş emri oluşsun". İş emri artık yalnızca sistemin
  // önerisinden doğmuyor; kullanıcı kendi kararıyla da açabiliyor.
  const [yaratAcik, setYaratAcik] = useState(false);
  const [yKampanyalar, setYKampanyalar] = useState([]);
  const [ySetler, setYSetler] = useState([]);
  const [yKampanya, setYKampanya] = useState('');
  const [ySet, setYSet] = useState('');
  const [yNot, setYNot] = useState('');
  const [yMesgul, setYMesgul] = useState(false);
  const [yHata, setYHata] = useState('');

  // İŞ EMRİNİ İPTAL (kullanıcı talebi: 2026-10-02) — iki farklı davranış:
  //   KARARLAR'dan gelen → karara geri döner, orada yeniden kabul/red edersin
  //   elle açılan        → tamamen silinir, arşivlenmez
  // Ayrımı sunucu da aynı kurala göre yapıyor; buradaki kontrol yalnızca düğme yazısı
  // ve onay metni doğru çıksın diye.
  const [iptalde, setIptalde] = useState(null);
  const elleAcilmis = (o) => !(o.detay || '').startsWith('{');

  // KARARLAR'dan gelen iş emirlerinde DETAY alanı, kararın JSON anlık görüntüsüdür — iş emri
  // iptal edilince kararı aynen geri döndürebilmek için saklanıyor. Bu teknik bir kayıt,
  // kullanıcıya gösterilecek bir metin değil; ham hâliyle ekrana basılınca okunmaz bir blok
  // çıkıyordu (2026-10-02). Aynı içerik aşağıda okunabilir biçimde yazılıyor.
  const detayCoz = (d) => {
    const m = (d || '').trim();
    if (!m.startsWith('{')) return null;
    try { return JSON.parse(m); } catch { return null; }
  };

  const isEmriIptalEt = (o) => {
    const elle = elleAcilmis(o);
    const soru = elle
      ? 'Bu iş emri TAMAMEN SİLİNECEK (sen açmıştın, geri dönülecek bir karar yok). Emin misin?'
      : 'Bu iş emri iptal edilip KARARLAR ekranına geri dönecek; orada yeniden kabul ya da red edebilirsin. Devam?';
    if (!window.confirm(soru)) return;
    setIptalde(o.id); setHata('');
    isEmriIptal(o.id)
      .then(() => yukle())
      .catch(e => setHata(e.response?.data?.hata || e.message))
      .finally(() => setIptalde(null));
  };

  // YALNIZ AKTİF OLANLAR (kullanıcı talebi: 2026-10-02). Durmuş bir sete kreatif üretmenin
  // anlamı yok — üretilen reklam yayına giremez, iş emri boşa açılır. Hesapta 190 kampanyanın
  // 171'i durmuş durumda (ölçüldü), listeyi onlarla doldurmak seçimi de zorlaştırıyordu.
  const aktifMi = (x) => (x.durum || x.Durum) === 'ACTIVE';

  const yaratAc = () => {
    setYaratAcik(true); setYHata(''); setYKampanya(''); setYSet(''); setYSetler([]); setYNot('');
    if (yKampanyalar.length === 0) {
      yapiKampanyalar()
        .then(r => setYKampanyalar((r.data?.kampanyalar || r.data || []).filter(aktifMi)))
        .catch(e => setYHata(e.response?.data?.hata || e.message));
    }
  };

  const kampanyaSec = (id) => {
    setYKampanya(id); setYSet(''); setYSetler([]); setYHata('');
    if (!id) return;
    yapiSetler(id)
      .then(r => {
        const hepsi = r.data?.setler || r.data || [];
        const aktif = hepsi.filter(aktifMi);
        setYSetler(aktif);
        if (aktif.length === 0 && hepsi.length > 0)
          setYHata('Bu kampanyanın yayında seti yok — durmuş bir sete kreatif üretilemez.');
      })
      .catch(e => setYHata(e.response?.data?.hata || e.message));
  };

  const isEmriOlustur = () => {
    const k = yKampanyalar.find(x => (x.id || x.Id) === yKampanya);
    const s = ySetler.find(x => (x.id || x.Id) === ySet);
    setYMesgul(true); setYHata('');
    isEmriAc({
      kampanyaId: yKampanya, kampanyaAdi: k?.ad || k?.Ad,
      setId: ySet, setAdi: s?.ad || s?.Ad, not: yNot,
    })
      .then(() => { setYaratAcik(false); yukle(); })
      .catch(e => setYHata(e.response?.data?.hata || e.message))
      .finally(() => setYMesgul(false));
  };
  // Gözden Geçir önerileri AKSİYON listesini boğuyordu (kullanıcı: "kirlilik yaratıyor",
  // 2026-08-19): aksiyon gerektirenler ile "insan gözüyle bak" diyenler ayrı sekmelerde.
  // Acilis PASIFE AL'da: para yakan reklamlar once gorunsun (kullanici talebi: 2026-08-19).
  const [sekme, setSekme] = useState('hepsi');   // kreatif is turu | hepsi

  // Kategori görünümleri — renk ve okunur ad.
  // BU EKRANDA YALNIZ KREATİF İŞLERİ VAR (kullanıcı: 2026-10-02 "içerik stüdyosunda hâlâ çöp var").
  //
  // Pasife Al / Bütçe Değişikliği / Gözden Geçir türleri BURAYA AİT DEĞİL — onlar KARARLAR
  // ekranında kabul edilip Meta'ya yazılan ya da not olarak işaretlenen kararlar; stüdyoda
  // üretilecek bir şey yok. Sekme olarak durmaları ekranı yanıltıyordu.
  const KATEGORI = {
    YeniReklamIcerigi: { ad: 'Yeni Reklam İçeriği', renk: '#1F6FB2', zemin: '#EAF1F8', simge: '🎨' },
    YeniOlustur:       { ad: 'Yeni Oluştur',        renk: '#1D7A56', zemin: '#EAF6F0', simge: '✨' },
  };
  const kategoriBilgi = (t) => KATEGORI[t] || { ad: t || 'Öneri', renk: '#5A6B78', zemin: '#F2F4F7', simge: '•' };

  const SEVIYE = { Kampanya: 'Kampanya', ReklamSeti: 'Reklam Seti', Reklam: 'Reklam' };
  const tarihFormat = (v) => v ? new Date(v).toLocaleString('tr-TR') : '-';
  // ONBELLEK KIRICI (2026-08-25): uretilen dosyanin adi degismiyor (final-9.mp4), icerigi
  // degisiyor. Adres birebir ayni kalinca tarayici eskisini gosteriyor ve kullanici "uretim
  // olmadi" saniyordu. Her uretimde degisen bir damga ekliyoruz.
  const tazeAdres = (yol, damga) => yol ? reklamApiKok + yol + '?v=' + encodeURIComponent(damga || '') : '';

  const asamaKutu = (bitti) => ({
    border: `1px solid ${bitti ? '#BFE0D0' : 'var(--border)'}`,
    background: bitti ? '#F4FBF8' : '#fff',
    borderRadius: 7, padding: 10, marginBottom: 8,
  });
  const asamaBaslik = { display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, fontWeight: 700, marginBottom: 6 };
  const rozet = { fontSize: 10.5, fontWeight: 700, color: '#1D7A56', background: '#EAF6F0', borderRadius: 999, padding: '2px 8px' };
  const asamaDugmesi = (bitti, mesgul) => ({
    background: mesgul ? '#E4E9EA' : (bitti ? '#fff' : '#1D9E75'),
    color: mesgul ? '#9AA7AC' : (bitti ? '#1D7A56' : '#fff'),
    border: bitti && !mesgul ? '1px solid #1D7A56' : 'none',
    borderRadius: 6, padding: '7px 18px', fontSize: 12.5, fontWeight: 700,
    cursor: mesgul ? 'default' : 'pointer',
  });

  // İÇERİK STÜDYOSU ARTIK YALNIZCA İŞ EMİRLERİNİ GÖSTERİR — kullanıcı kararı: 2026-10-01.
  //
  // Eskiden burada HER karar türü listeleniyordu (durdurma, bütçe, hedefleme...). Artık o
  // işlerin yeri KARARLAR ekranı: kabul/red orada veriliyor ve Meta'ya orada yazılıyor.
  // Buraya yalnızca KABUL EDİLMİŞ bir kararın doğurduğu KREATİF İŞİ düşer.
  //
  // Kullanıcının tarifi: "yeni kreatif hazırlama iş emirleri oraya düşüp bizi bekleyecek —
  // emir diyorum çünkü biz kararlar ekranında kabul etmiş oluyoruz, o artık emirdir."
  const IS_EMRI_TURLERI = ['YeniOlustur', 'YeniReklamIcerigi'];

  // "HEPSİ" DE KARAR VERİLMEMİŞLERİ GÖSTERMEZ (kullanıcı: 2026-10-06).
  // "Bekliyor" sekmesi 2026-10-02'de kaldırılmıştı ama "Hepsi" sunucuda hiçbir durum
  // süzgeci uygulamadığı için onları geri getiriyordu: 49 satırın 45'i karar verilmemiş,
  // 27'si 29 Eylül taramasından — yani eşikler yeniden türetilmeden önceki hesapla
  // yazılmış metinler. Bir karar kabul edilmeden iş emri DEĞİLDİR; yeri KARARLAR ekranı.
  const IS_EMRI_MI = (o) => (o.durum || o.Durum) !== 'Bekliyor';

  const yukle = useCallback(() => {
    setDurum('yukleniyor');
    aiOneriler(filtre)
      .then(r => {
        const d = r.data || {};
        setVeri({
          ...d,
          oneriler: (d.oneriler || [])
            .filter(o => IS_EMRI_TURLERI.includes(o.kararTuru))
            .filter(IS_EMRI_MI),
        });
        setDurum('hazir');
      })
      .catch(err => { setHata(err.response?.data?.hata || err.message); setDurum('hata'); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtre]);

  useEffect(() => { yukle(); }, [yukle]);

  const ac = (id) => {
    setIcerik(null); setIcerikDurum(''); setNotlar({}); setDuzenlenen({}); setYayinOnizleme(null); setYayinDurumu(null); setSeciliSet(null); setOnizlemeler([]); setSeciliYerlesim(null); setVideoKaynak(null); setAcikParca({}); setBriefTur(null); setBriefCinsiyet(''); setAnaFikir(''); setCerceveDurum(''); setSeciliSes(''); setAsamaDurum({ asama: null, sn: 0 }); setRapor(null); setRaporHata('');
    oneriDetay(id).then(r => {
      setSecili(r.data);
      // İçerik üretilebilecek bir iş emriyse mevcut brief'i getir.
      if (r.data.kararTuru === 'YeniOlustur' || r.data.kararTuru === 'YeniReklamIcerigi') {
        icerikKararaGore(id).then(x => setIcerik(x.data.icerik)).catch(() => {});
      }
    }).catch(() => {});
  };

  const icerikYenile = (kararId) =>
    icerikKararaGore(kararId).then(x => setIcerik(x.data.icerik)).catch(() => {});

  const parcaEylem = (parca, eylem) => {
    setIslenenParca(parca);
    setIslenenEylem(eylem);
    setIcerikDurum(eylem === 'YenidenUret' ? 'Claude yeniden yazıyor...' : 'Kaydediliyor...');
    icerikParca(icerik.id, {
      parca, eylem,
      deger: eylem === 'BunuKullan' ? (duzenlenen[parca] || '') : undefined,
      not: eylem === 'YenidenUret' ? (notlar[parca] || '') : undefined,
    })
      .then(r => {
        setIcerik(r.data.icerik);
        setIcerikDurum('');
        if (eylem === 'BunuKullan') setDuzenlenen(d => ({ ...d, [parca]: undefined }));
        if (eylem === 'YenidenUret') setNotlar(n => ({ ...n, [parca]: '' }));
        setAcikParca(a => ({ ...a, [parca]: false }));
      })
      .catch(e => setIcerikDurum('✗ ' + (e.response?.data?.mesaj || e.response?.data?.hata || e.message)))
      // MEŞGUL İŞARETİ MUTLAKA TEMİZLENİR — bu satır eksikti (2026-08-21): kart "Claude
      // yazıyor" durumunda asılı kalıyor, kullanıcı ekranı yenilemeden başka bir bölümü
      // onaylayamıyordu. Onay isteği saniyeler sürer, cevabı beklemek doğru; asılı kalmak değil.
      .finally(() => { setIslenenParca(null); setIslenenEylem(null); });
  };

  // Hangi model çalışacak ve kalan kredi ne — ÜRET'e basmadan ÖNCE gösterilir.
  useEffect(() => {
    if (icerik && icerik.uretimeHazir && !uretimBilgi) {
      icerikUretimBilgisi().then(r => setUretimBilgi(r.data)).catch(() => {});
    }
  }, [icerik, uretimBilgi]);

  // Yayınlanmış bir içerik açıldığında durumu Meta'dan oku — ekranda "yayında mı, durdu mu"
  // sorusu cevapsız kalmasın.
  useEffect(() => {
    if (icerik?.metaReklamId && !yayinDurumu) {
      icerikYayinDurumu(icerik.id).then(r => setYayinDurumu(r.data)).catch(() => {});
    }
  }, [icerik, yayinDurumu]);

  // ŞABLON LİSTESİ ARTIK 3. AŞAMADA SORULUR (kullanıcı kararı: 2026-08-25).
  // Brief ekranından kaldırıldı: şablon yalnızca finalin nasıl kurulacağını belirler,
  // Claude'un yazdığı metni ilgilendirmiyordu.
  const uretimTuru = icerik
    ? (icerik.medyaTuru !== 'video'
        ? 'resim|resim'
        : ((videoKaynak || icerik.videoKaynak || 'resim') === 'video' ? 'video|video' : 'video|resim'))
    : null;
  useEffect(() => {
    if (!uretimTuru) { setSablonlar([]); return; }
    const [tur, kaynak] = uretimTuru.split('|');
    icerikSablonlar(tur, kaynak)
      .then(r => { setSablonlar(r.data.sablonlar || []); setSeciliSablon(''); })
      .catch(() => setSablonlar([]));
  }, [uretimTuru]);

  // Seslendirme sesleri — Şablonlar ekranından eklenir, buradan yalnızca seçilir.
  useEffect(() => {
    sesListe().then(r => setSesler((r.data.sesler || []).filter(x => x.aktif))).catch(() => setSesler([]));
  }, []);

  // Çerçeve (cinsiyet + ana fikir) metinlere DOKUNMAZ; bundan sonraki "yeniden oluştur"
  // çağrılarında uygulanır. Bu yüzden kaydetmek bir onayı geçersiz kılmıyor.
  // Çerçeve metinlere DOKUNMAZ; yalnızca bundan sonraki "yeniden oluştur" çağrılarında
  // Claude'a gider. Bu yüzden değiştirmek mevcut onayları bozmuyor.
  const cerceveDegistir = (cinsiyet) => {
    setCerceveDurum('Kaydediliyor...');
    cerceveKaydet(icerik.id, cinsiyet, icerik.anaFikir || null)
      .then(r => {
        setIcerik(r.data.icerik);
        setCerceveDurum('✓ kaydedildi');
      })
      .catch(e => setCerceveDurum('✗ ' + (e.response?.data?.hata || e.message)));
  };

  // TEK "ÜRET" YERİNE ÜÇ AŞAMA (kullanıcı tasarımı: 2026-08-25).
  // Eskiden tek düğme üç yapay zekayı birden çalıştırıyordu; kullanıcı yalnızca sesi
  // beğenmediğinde bile görseli ve render'ı yeniden ödemek zorunda kalıyordu.
  const asamaCalistir = (asama) => {
    const video = icerik.medyaTuru === 'video';
    const kaynak = video ? (videoKaynak || icerik.videoKaynak || 'resim') : 'resim';
    const ad = asama === 'medya' ? (video ? 'VİDEO' : 'GÖRSEL') : asama === 'ses' ? 'SESLENDİRME' : 'FİNAL';
    const bedel = asama === 'medya'
      ? (video && kaynak === 'video'
          ? `TopView video kredisi — ${uretimBilgi?.video?.model || 'video modeli'} (~24 kat pahalı)`
          : `TopView kredisi — ${uretimBilgi?.gorsel?.model || 'görsel modeli'}`)
      : asama === 'ses' ? 'ElevenLabs kredisi' : 'Creatomate render kredisi';
    // Medya veya ses değişirse eldeki final artık yanlış medyayı taşır: sunucu onu siler.
    const uyari = (asama !== 'final' && icerik.finalHazir)
      ? '\n\nDİKKAT: hazır final silinecek, 3. aşamayı yeniden çalıştırmanız gerekir.' : '';
    if (!window.confirm(`${ad} üretilsin mi?\n\nHarcanacak: ${bedel}${uyari}`)) return;

    const istek = asama === 'medya'
      ? medyaUret(icerik.id, { tur: video ? 'video' : 'resim', kaynak })
      : asama === 'ses'
        ? sesUret(icerik.id, seciliSes || icerik.parcalar?.seslendirme?.ses || undefined)
        : finalUret(icerik.id, seciliSablon || undefined);

    setAsamaDurum({ asama, sn: 0 });
    setIcerikDurum('');
    istek
      .then(r => {
        if (r.data.atlandi) {
          setAsamaDurum({ asama: null, sn: 0 });
          setIcerik(r.data.icerik);
          setIcerikDurum('✓ ' + r.data.mesaj);
          return;
        }
        setIcerik(r.data.icerik);
        // ÜRETİM ARKA PLANDA ÇALIŞIR (2026-08-20): IIS proxy 2 dakikada kesiyordu.
        const basla = Date.now();
        const sor = setInterval(() => {
          icerikDetay(icerik.id).then(x => {
            const g = x.data.icerik;
            if (g.uretimSuruyor) { setAsamaDurum({ asama, sn: Math.round((Date.now() - basla) / 1000) }); return; }
            clearInterval(sor);
            setAsamaDurum({ asama: null, sn: 0 });
            setIcerik(g);   // pencere kendini tazeler — kullanıcı elle yenilemesin
            setIcerikDurum(g.hataMesaji ? '✗ ' + g.hataMesaji : `✓ ${ad} hazır.`);
            icerikUretimBilgisi().then(y => setUretimBilgi(y.data)).catch(() => {});
          }).catch(() => {});
        }, 5000);
      })
      .catch(e => {
        setAsamaDurum({ asama: null, sn: 0 });
        setIcerikDurum('✗ ' + (e.response?.data?.mesaj || e.response?.data?.hata || e.message));
      });
  };

  // GÖZDEN GEÇİR'in üç çıkışı — "Kabul Et / Reddet" bu tür için anlamsızdı: sistem zaten
  // karar veremediği için soruyor (kullanıcı tasarımı: 2026-08-19).
  const gozdenEylem = (id, eylem) => {
    setIslemde(true);
    gozdenGecirEylem(id, eylem)
      .then(() => { setSecili(null); yukle(); })
      .catch(e => window.alert('İşlem yapılamadı: ' + (e.response?.data?.hata || e.message)))
      .finally(() => setIslemde(false));
  };

  const kararVer = (id, onay) => {
    setIslemde(true);
    (onay ? kararOnayla(id) : kararReddet(id))
      .then(() => { setSecili(null); yukle(); })
      .finally(() => setIslemde(false));
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 4 }}>
        <h3 style={{ fontSize: 15, fontWeight: 600, margin: 0 }}>İçerik Stüdyosu — İş Emirleri</h3>
        <button onClick={yaratAc} style={{
          marginLeft: 'auto', padding: '8px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer',
          background: '#1D9E75', color: '#fff', border: '1px solid #178460', borderRadius: 7,
        }}>+ Kreatif Yarat</button>
      </div>
      <div style={{
        fontSize: 12, color: '#1F4E7A', background: '#EEF4FB', border: '1px solid #B7CFE6',
        borderLeft: '3px solid #3D6E9E', borderRadius: 7, padding: '8px 11px', marginBottom: 12, lineHeight: 1.6,
      }}>
        İş emirleri iki yoldan gelir: <strong>KARARLAR ekranında kabul ettiğin</strong> bir kararın
        devamı olarak, ya da <strong>+ Kreatif Yarat</strong> ile kendi açtığın emir. İkisi de
        burada kreatifi üretilmeyi bekler.
      </div>

      {/* KREATİF YARAT PENCERESİ (kullanıcı talebi: 2026-10-02) — kampanya seç, sonra set seç. */}
      {yaratAcik && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(31,47,70,.45)', zIndex: 50,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
        }} onClick={() => !yMesgul && setYaratAcik(false)}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 12, padding: 20, width: 'min(560px, 100%)',
            boxShadow: '0 12px 40px rgba(0,0,0,.25)',
          }}>
            <h4 style={{ margin: '0 0 4px', fontSize: 16 }}>Yeni kreatif iş emri</h4>
            <p style={{ margin: '0 0 16px', fontSize: 12.5, color: '#6B7A8C', lineHeight: 1.6 }}>
              Kreatifin hangi reklam setinin içinde yayınlanacağını seç. İş emri oluşur,
              üretimi buradan başlatırsın. <strong>Meta'ya bu adımda hiçbir şey yazılmaz.</strong>
            </p>

            <label style={{ display: 'grid', gap: 4, fontSize: 12, fontWeight: 700, color: '#4A5A6E', marginBottom: 12 }}>
              Kampanya <span style={{ fontWeight: 400, color: "#8C99A8" }}>(yalnızca yayındakiler)</span>
              <select value={yKampanya} onChange={e => kampanyaSec(e.target.value)}
                      style={{ height: 36, padding: '4px 9px', fontSize: 13.5, border: '1px solid #C9D2DC', borderRadius: 6 }}>
                <option value="">— seçiniz —</option>
                {yKampanyalar.map(k => (
                  <option key={k.id || k.Id} value={k.id || k.Id}>{k.ad || k.Ad}</option>
                ))}
              </select>
            </label>

            <label style={{ display: 'grid', gap: 4, fontSize: 12, fontWeight: 700, color: '#4A5A6E', marginBottom: 12 }}>
              Reklam seti <span style={{ fontWeight: 400, color: "#8C99A8" }}>(yalnızca yayındakiler)</span>
              <select value={ySet} onChange={e => setYSet(e.target.value)} disabled={!yKampanya}
                      style={{ height: 36, padding: '4px 9px', fontSize: 13.5, border: '1px solid #C9D2DC', borderRadius: 6 }}>
                <option value="">{yKampanya ? '— seçiniz —' : 'önce kampanya seç'}</option>
                {ySetler.map(s => (
                  <option key={s.id || s.Id} value={s.id || s.Id}>{s.ad || s.Ad}</option>
                ))}
              </select>
            </label>

            <label style={{ display: 'grid', gap: 4, fontSize: 12, fontWeight: 700, color: '#4A5A6E', marginBottom: 14 }}>
              Not <span style={{ fontWeight: 400, color: '#8C99A8' }}>(isteğe bağlı — ne anlatsın?)</span>
              <input value={yNot} onChange={e => setYNot(e.target.value)}
                     placeholder="örn. kış kampanyası, skolyoz farkındalığı"
                     style={{ height: 36, padding: '4px 9px', fontSize: 13.5, border: '1px solid #C9D2DC', borderRadius: 6 }} />
            </label>

            {yHata && <div style={{ marginBottom: 12, padding: '8px 11px', fontSize: 12.5,
              background: '#FDECEC', border: '1px solid #F0B4B4', borderRadius: 7, color: '#A12626' }}>{yHata}</div>}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setYaratAcik(false)} disabled={yMesgul} style={{
                padding: '9px 16px', fontSize: 13, cursor: 'pointer',
                background: '#fff', border: '1px solid #C9D2DC', borderRadius: 7, color: '#4A5A6E' }}>Vazgeç</button>
              <button onClick={isEmriOlustur} disabled={!ySet || yMesgul} style={{
                padding: '9px 18px', fontSize: 13, fontWeight: 700, cursor: ySet ? 'pointer' : 'default',
                background: ySet ? '#1D9E75' : '#B9C6D2', color: '#fff', border: 'none', borderRadius: 7 }}>
                {yMesgul ? 'Oluşturuluyor...' : 'İş emri oluştur'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ÜST SEKME = İŞ TÜRÜ, ALT FİLTRE = DURUM (kullanıcı talebi: 2026-08-19).
          Önce üst sekmelerin sayıları alt filtreye göre değişiyordu; kullanıcı "garip bir
          filtre sistemi, insan kayboluyor" dedi. Artık üst sekmedeki rakam TOPLAM iş sayısı
          (durumdan bağımsız) ve sıfır bile olsa her tür listede duruyor — ekran tıklamayla
          şekil değiştirmiyor. */}
      <div style={{ display: 'flex', gap: 4, borderBottom: '2px solid var(--border)',
                    marginBottom: 12, flexWrap: 'wrap' }}>
        {[...Object.keys(KATEGORI).map(k => ({ k, ad: KATEGORI[k].ad })),
          { k: 'hepsi', ad: 'Tümü' }]
          .map(t => {
            // Sayılar artık SUNUCUNUN tür dökümünden değil, EKRANDAKİ listeden hesaplanıyor
            // (2026-10-02). Sunucu tüm karar türlerini sayıyordu; bu ekranda yalnız kreatif
            // işleri olduğu için o rakamlar ekranla uyuşmuyor, "98" gibi hayalet sayı çıkıyordu.
            const liste = (veri && veri.oneriler) || [];
            const sayi = t.k === 'hepsi'
              ? liste.length
              : liste.filter(o => o.kararTuru === t.k).length;
            const secili = sekme === t.k;
            const renk = t.k === 'hepsi' ? '#1D9E75' : KATEGORI[t.k].renk;
            return (
              <button key={t.k} onClick={() => setSekme(t.k)} style={{
                background: 'none', border: 'none', cursor: 'pointer', padding: '8px 13px',
                fontSize: 12.5, fontWeight: secili ? 700 : 500,
                color: secili ? renk : (sayi === 0 ? '#B9C2C6' : 'var(--text-muted)'),
                borderBottom: secili ? `2px solid ${renk}` : '2px solid transparent',
                marginBottom: -2, whiteSpace: 'nowrap',
              }}>
                {t.k !== 'hepsi' && <span style={{ marginRight: 5 }}>{KATEGORI[t.k].simge}</span>}
                {t.ad} ({sayi})
              </button>
            );
          })}
      </div>

      {/* DURUM KAVRAMLARI — kullanıcı talebi: 2026-08-18. Eskiden "Onaylandı" iki farklı şeyi
          birden anlatıyordu: hem "kabul ettim ama uygulanmadı" hem "Meta'ya yazıldı". Aradaki
          fark ayrıldı; geri alma yalnızca "Uygulandı" aşamasında mümkün. */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
        {[
          // "BEKLİYOR" SEKMESİ KALDIRILDI (kullanıcı: 2026-10-02 "içerik stüdyosunda hâlâ çöp var").
          //
          // Bekleyen bir karar HENÜZ İŞ EMRİ DEĞİLDİR — kullanıcı onu kabul etmemiştir, yeri
          // KARARLAR ekranıdır. Burada görünmesi ekranın kendi açıklamasıyla da çelişiyordu:
          // "buradaki her satır senin kabul ettiğin bir kararın devamıdır" yazarken kabul
          // edilmemiş 73 kararı listeliyordu.
          { k: 'KabulEdildi', e: 'Bekleyen iş emri',      a: 'Kabul ettin, kreatif henüz Meta\'ya yazılmadı' },
          { k: 'Uygulandi',   e: 'Uygulandı',             a: 'Meta\'ya yazıldı — buradan geri alınabilir' },
          { k: 'Reddedildi',  e: 'Reddedildi',            a: 'Uygulanmayacak' },
          { k: 'Hepsi',       e: 'Hepsi',                 a: 'Tüm iş emirleri — arşiv ve karar verilmemiş öneriler hariç' },
          { k: 'Arsiv',       e: 'Arşiv',                 a: 'Temizlik sırasında listeden çıkarılanlar — silinmediler' },
        ].map(d => (
          <button key={d.k} onClick={() => setFiltre(d.k)} title={d.a} style={{
            border: '1px solid var(--border)', borderRadius: 6, padding: '5px 12px', fontSize: 12,
            cursor: 'pointer', fontWeight: filtre === d.k ? 700 : 400,
            background: filtre === d.k ? '#1D9E75' : '#fff', color: filtre === d.k ? '#fff' : 'var(--text-muted)',
          }}>{d.e}</button>
        ))}
      </div>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 12 }}>
        Üstteki sekme <strong>iş türünü</strong> seçer, buradaki düğmeler
        <strong> listede hangi durumu göreceğinizi</strong>. Bekleyen iş emri → kabul ettin,
        kreatif üretilmedi · Uygulandı → Meta'ya yazıldı, geri alınabilir.
        Karar verilmemiş öneriler burada <strong>hiç görünmez</strong> — onların yeri KARARLAR ekranı.
      </div>

      {durum === 'yukleniyor' && <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>⏳ Yükleniyor...</div>}
      {durum === 'hata' && <div style={{ color: '#D9534F', fontSize: 13 }}>● {hata}</div>}

      {durum === 'hazir' && (
        <div style={{ background: '#fff', border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden' }}>
          {(() => {
            const liste = sekme === 'hepsi'
              ? veri.oneriler
              : veri.oneriler.filter(o => o.kararTuru === sekme);
            return liste.length === 0 ? (
            <div style={{ padding: 16, color: 'var(--text-muted)', fontSize: 13 }}>
              Bu durumda bekleyen iş emri yok. İş emirleri <strong>yalnızca KARARLAR ekranından</strong>
              {' '}düşer: orada bir kreatif önerisini kabul ettiğinde ya da bir seti durdurup yerine
              {' '}yenisini açtırdığında, o setin kreatifi için buraya iş emri gelir.
            </div>
            ) : liste.map(o => {
            const k = kategoriBilgi(o.kararTuru);
            return (
              <div key={o.id} onClick={() => ac(o.id)} style={{
                padding: '12px 14px', borderBottom: '1px solid var(--border)', cursor: 'pointer',
                display: 'flex', gap: 12, alignItems: 'center',
              }}>
                <span style={{
                  background: k.zemin, color: k.renk, borderRadius: 6, padding: '4px 10px',
                  fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap',
                }}>{k.simge} {k.ad}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>
                    {o.reklamAdi || o.setAdi || o.kampanyaAdi}
                    {o.seviye && (
                      <span style={{ marginLeft: 8, fontSize: 11, color: 'var(--text-muted)', fontWeight: 400 }}>
                        ({SEVIYE[o.seviye] || o.seviye} seviyesi)
                      </span>
                    )}
                  </div>
                  <div style={{
                    fontSize: 12, color: 'var(--text-muted)', marginTop: 2,
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                  }}>{o.gerekce}</div>
                </div>
                <span style={{ fontSize: 11, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>
                  {tarihFormat(o.olusturulmaZamani)}
                </span>
                {/* İŞ EMRİNİ İPTAL (kullanıcı talebi: 2026-10-02) — nereden geldiğine göre
                    iki farklı davranış; düğme hangisi olacağını önceden söylüyor. */}
                <button onClick={(e) => { e.stopPropagation(); isEmriIptalEt(o); }}
                        disabled={iptalde === o.id}
                        title={elleAcilmis(o)
                          ? 'Bu emri sen açtın — iptal edince tamamen silinir'
                          : 'Bu emir bir karardan geldi — iptal edince KARARLAR ekranına geri döner'}
                        style={{
                          background: 'none', border: '1px solid #E6C9C9', borderRadius: 6,
                          padding: '4px 10px', fontSize: 11.5, color: '#A12626',
                          cursor: iptalde === o.id ? 'default' : 'pointer', whiteSpace: 'nowrap',
                        }}>
                  {iptalde === o.id ? '...' : (elleAcilmis(o) ? '✕ Sil' : '↩ Karara döndür')}
                </button>
              </div>
            );
            });
          })()}
        </div>
      )}

      {/* Pop-up: önerinin ayrıntısı */}
      {secili && (
        <div onClick={() => setSecili(null)} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 10, maxWidth: 720, width: '100%',
            maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
          }}>
            {(() => {
              const k = kategoriBilgi(secili.kararTuru);
              return (
                <>
                  <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--border)', background: k.zemin, position: 'relative' }}>
                    <div style={{ color: k.renk, fontWeight: 700, fontSize: 12 }}>{k.simge} {k.ad.toUpperCase()}</div>
                    <div style={{ fontSize: 17, fontWeight: 600, marginTop: 4, paddingRight: 40 }}>
                      {secili.reklamAdi || secili.setAdi || secili.kampanyaAdi}
                    </div>
                    {/* Kapat: Windows pencerelerindeki gibi sağ üst köşede belirgin kırmızı X
                        (kullanıcı talebi: 2026-08-18). Alttaki "Kapat" butonu kaldırıldı —
                        aynı işi iki yerde yapan buton kafa karıştırıyordu. */}
                    <button onClick={() => setSecili(null)} title="Kapat"
                      onMouseEnter={e => { e.currentTarget.style.background = '#A93226'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = '#C0392B'; }}
                      style={{
                        position: 'absolute', top: 10, right: 12,
                        width: 30, height: 30, lineHeight: '30px', textAlign: 'center',
                        background: '#C0392B', color: '#fff', border: 'none', borderRadius: 5,
                        fontSize: 17, fontWeight: 700, cursor: 'pointer', padding: 0,
                      }}>×</button>
                  </div>

                  <div style={{ padding: 20, fontSize: 13, lineHeight: 1.7 }}>
                    {/* MEDYA — yalnızca reklam seviyesindeki önerilerde (kullanıcı, 2026-08-17).
                        Karar verilen şey zaten görselin kendisi; "hangi reklam" sorusunun cevabı
                        adıyla değil medyasıyla verilmeli. Önizleme Meta'nın kendi bağlantısı,
                        yeni sekmede açılır. */}
                    {(secili.kucukGorsel || secili.onizlemeBaglantisi) && (
                      <div style={{
                        display: 'flex', gap: 12, alignItems: 'center', marginBottom: 14,
                        padding: 10, background: '#fafafa', border: '1px solid var(--border)', borderRadius: 6,
                      }}>
                        {secili.kucukGorsel && (
                          <img src={secili.kucukGorsel} alt="reklam medyası"
                               style={{ width: 84, height: 84, objectFit: 'cover', borderRadius: 4, border: '1px solid var(--border)' }} />
                        )}
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontWeight: 600, fontSize: 12, marginBottom: 4 }}>Reklamın medyası</div>
                          {secili.onizlemeBaglantisi ? (
                            <a href={secili.onizlemeBaglantisi} target="_blank" rel="noreferrer"
                               style={{ fontSize: 12, color: '#1D7A56', fontWeight: 600 }}>
                              ▶ Reklamı Meta'da önizle
                            </a>
                          ) : (
                            <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                              Önizleme bağlantısı yok — yalnızca küçük görsel mevcut.
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    <table style={{ width: '100%', fontSize: 12, marginBottom: 14 }}>
                      <tbody>
                        {/* KIRILIM HER ZAMAN GÖRÜNÜR — kullanıcı talebi: 2026-08-18. Eskiden boş
                            olan satır hiç yazılmıyordu; "hangi kampanyanın hangi seti" sorusu
                            cevapsız kalıyordu. Artık boşsa "—" yazıyor, hangi seviyenin kararı
                            olduğu da işaretleniyor. */}
                        <tr>
                          <td style={{ color: 'var(--text-muted)', width: 110 }}>Kampanya</td>
                          <td style={{ fontWeight: secili.seviye === 'Kampanya' ? 700 : 400 }}>
                            {secili.kampanyaAdi || '—'}
                            {secili.seviye === 'Kampanya' && <span style={{ color: '#1F6FB2', fontSize: 11 }}> ← karar bu seviyede</span>}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ color: 'var(--text-muted)' }}>Reklam Seti</td>
                          <td style={{ fontWeight: secili.seviye === 'ReklamSeti' ? 700 : 400 }}>
                            {/* REKLAM YAYINDAYSA GERÇEK SET YAZILIR (kullanıcı kararı: 2026-08-31).
                                Bu satır iş emrinin çıktığı seti gösteriyordu; reklam başka sete
                                taşınınca (ör. ŞÜKRÜ ÖZEL) ekranda hâlâ eski set duruyor ve
                                "neden hâlâ bu yazıyor" sorusuna yol açıyordu. Kullanıcı iş emrinin
                                kaynağını değil reklamın bugün nerede olduğunu görmek istiyor. */}
                            {yayinDurumu?.setAdi || secili.setAdi || '—'}
                            {secili.seviye === 'ReklamSeti' && !yayinDurumu?.setAdi && (
                              <span style={{ color: '#1F6FB2', fontSize: 11 }}> ← öneri bu set için üretildi</span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ color: 'var(--text-muted)' }}>Reklam</td>
                          <td style={{ fontWeight: secili.seviye === 'Reklam' ? 700 : 400 }}>
                            {secili.reklamAdi || yayinDurumu?.reklamAdi || '—'}
                            {secili.seviye === 'Reklam' && <span style={{ color: '#1F6FB2', fontSize: 11 }}> ← karar bu seviyede</span>}
                            {!secili.reklamAdi && yayinDurumu?.reklamAdi && (
                              <span style={{ color: 'var(--text-muted)', fontSize: 11 }}> (bu iş emrinden üretildi)</span>
                            )}
                          </td>
                        </tr>
                        {secili.oncekiDeger && <tr><td style={{ color: 'var(--text-muted)' }}>Şu an</td><td>{secili.oncekiDeger}</td></tr>}
                        {secili.onerilenDeger && <tr><td style={{ color: 'var(--text-muted)' }}>Önerilen</td><td><strong>{secili.onerilenDeger}</strong></td></tr>}
                        <tr><td style={{ color: 'var(--text-muted)' }}>Oluşturulma</td><td>{tarihFormat(secili.olusturulmaZamani)}</td></tr>
                      </tbody>
                    </table>

                    <div style={{ background: '#fafafa', border: '1px solid var(--border)', borderRadius: 6, padding: 12, marginBottom: 14 }}>
                      <div style={{ fontWeight: 600, fontSize: 12, marginBottom: 4 }}>Gerekçe</div>
                      {secili.gerekce}
                    </div>

                    {/* BÜTÇE UYGULAMA — sistemin Meta'ya YAZDIĞI tek işlem. Önerilen rakam
                        değiştirilebilir; son söz kullanıcıda (kullanıcı kararı: 2026-08-18).
                        Uygulanan değişiklik geri alınabilir. */}
                    {secili.kararTuru === 'ButceDegisikligi' && (
                      <div style={{
                        background: '#FFF6E5', border: '1px solid #E8C468', borderRadius: 6,
                        padding: 12, marginBottom: 14,
                      }}>
                        <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 8 }}>Günlük bütçe</div>
                        <table style={{ fontSize: 12, marginBottom: 10 }}>
                          <tbody>
                            <tr>
                              <td style={{ color: 'var(--text-muted)', paddingRight: 12 }}>Mevcut</td>
                              <td><strong>{secili.mevcutButceKurus ? (secili.mevcutButceKurus / 100).toLocaleString('tr-TR') : '-'} ₺/gün</strong></td>
                            </tr>
                            <tr>
                              <td style={{ color: 'var(--text-muted)', paddingRight: 12 }}>Önerilen</td>
                              <td><strong style={{ color: '#B8860B' }}>{secili.onerilenButceKurus ? (secili.onerilenButceKurus / 100).toLocaleString('tr-TR') : '-'} ₺/gün</strong></td>
                            </tr>
                            {secili.uygulananButceKurus && (
                              <tr>
                                <td style={{ color: 'var(--text-muted)', paddingRight: 12 }}>Uygulanan</td>
                                <td><strong style={{ color: '#1D7A56' }}>{(secili.uygulananButceKurus / 100).toLocaleString('tr-TR')} ₺/gün</strong></td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        {secili.durum === 'Onaylandi' && !secili.uygulanmaZamani && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <span style={{ fontSize: 12 }}>Uygulanacak:</span>
                            <input type="number" min="100" step="10"
                              value={butce !== '' ? butce : (secili.onerilenButceKurus ? secili.onerilenButceKurus / 100 : '')}
                              onChange={e => setButce(e.target.value)}
                              style={{ width: 90, padding: '5px 8px', border: '1px solid var(--border)', borderRadius: 5, fontSize: 13 }} />
                            <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>₺/gün</span>
                            <button disabled={islemde} onClick={() => {
                              const deger = butce !== '' ? Number(butce) : (secili.onerilenButceKurus / 100);
                              setUygulamaDurumu('Uygulanıyor...');
                              kararUygula(secili.id, deger)
                                .then(r => { setUygulamaDurumu(`✓ Meta'ya yazıldı: ${r.data.oncekiButceTl} ₺ → ${r.data.yeniButceTl} ₺`); yukle(); })
                                .catch(e => setUygulamaDurumu('✗ ' + (e.response?.data?.mesaj || e.response?.data?.hata || e.message)));
                            }} style={{
                              background: '#B8860B', color: '#fff', border: 'none', borderRadius: 5,
                              padding: '6px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                            }}>Meta'da Uygula</button>
                          </div>
                        )}

                        {secili.uygulanmaZamani && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <span style={{ fontSize: 12, color: '#1D7A56', fontWeight: 600 }}>
                              ✓ {new Date(secili.uygulanmaZamani).toLocaleString('tr-TR')} tarihinde uygulandı
                            </span>
                            <button disabled={islemde} onClick={() => {
                              setUygulamaDurumu('Geri alınıyor...');
                              kararGeriAl(secili.id)
                                .then(r => { setUygulamaDurumu(`↩ Geri alındı: ${r.data.butceTl} ₺/gün`); yukle(); })
                                .catch(e => setUygulamaDurumu('✗ ' + (e.response?.data?.mesaj || e.message)));
                            }} style={{
                              border: '1px solid var(--border)', background: '#fff', borderRadius: 5,
                              padding: '5px 12px', fontSize: 12, cursor: 'pointer',
                            }}>Geri Al</button>
                          </div>
                        )}

                        {secili.durum === 'Bekliyor' && (
                          <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                            Uygulamak için önce "Kabul Et" deyin.
                          </div>
                        )}

                        {uygulamaDurumu && (
                          <div style={{ fontSize: 12, marginTop: 8, fontWeight: 600 }}>{uygulamaDurumu}</div>
                        )}
                      </div>
                    )}

                    {/* PASİFE ALMA — reklamı/seti Meta'da durdurur. Geri alınabilir. */}
                    {secili.kararTuru === 'PasifeAl' && (
                      <div style={{
                        background: '#FDECEA', border: '1px solid #E6A9A2', borderRadius: 6,
                        padding: 12, marginBottom: 14,
                      }}>
                        <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 6 }}>Yayından kaldırma</div>
                        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 8 }}>
                          {secili.seviye === 'Reklam' ? 'Reklam' : secili.seviye === 'ReklamSeti' ? 'Reklam seti' : 'Kampanya'} Meta'da <strong>PAUSED</strong> yapılacak. Harcama durur, veriler silinmez.
                        </div>

                        {/* İKİ SEÇENEK — kullanıcı kararı: 2026-08-18. Durdurmakla iş bitmiyor;
                            yerine yeni reklam açılması gerekebilir ve bunu hatırlatacak bir şey
                            yoktu. İlk seçenek durdurur VE aynı set için "Yeni Oluştur" önerisini
                            kuyruğa koyar; ikincisi sadece durdurur. */}
                        {secili.durum === 'Onaylandi' && !secili.uygulanmaZamani && (
                          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            <button disabled={islemde} onClick={() => {
                              setUygulamaDurumu('Uygulanıyor...');
                              kararUygula(secili.id, undefined, true)
                                .then(r => { setUygulamaDurumu(`✓ Durduruldu${r.data.takipEklendi ? ' · "Yeni Oluştur" önerisi kuyruğa eklendi' : ''}`); yukle(); })
                                .catch(e => setUygulamaDurumu('✗ ' + (e.response?.data?.mesaj || e.response?.data?.hata || e.message)));
                            }} style={{
                              background: '#C0392B', color: '#fff', border: 'none', borderRadius: 5,
                              padding: '6px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                            }}>Pasife Al ve Yenisini Oluştur</button>

                            <button disabled={islemde} onClick={() => {
                              setUygulamaDurumu('Uygulanıyor...');
                              kararUygula(secili.id)
                                .then(r => { setUygulamaDurumu(`✓ Meta'da durduruldu (${r.data.oncekiDurum} → ${r.data.yeniDurum})`); yukle(); })
                                .catch(e => setUygulamaDurumu('✗ ' + (e.response?.data?.mesaj || e.response?.data?.hata || e.message)));
                            }} style={{
                              background: '#fff', color: '#C0392B', border: '1px solid #C0392B', borderRadius: 5,
                              padding: '6px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                            }}>Sadece Pasife Al</button>
                          </div>
                        )}

                        {secili.uygulanmaZamani && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                            <span style={{ fontSize: 12, color: '#C0392B', fontWeight: 600 }}>
                              ⏸ {new Date(secili.uygulanmaZamani).toLocaleString('tr-TR')} tarihinde durduruldu
                            </span>
                            <button disabled={islemde} onClick={() => {
                              setUygulamaDurumu('Geri alınıyor...');
                              kararGeriAl(secili.id)
                                .then(() => { setUygulamaDurumu('↩ Tekrar ACTIVE yapıldı'); yukle(); })
                                .catch(e => setUygulamaDurumu('✗ ' + (e.response?.data?.mesaj || e.message)));
                            }} style={{
                              border: '1px solid var(--border)', background: '#fff', borderRadius: 5,
                              padding: '5px 12px', fontSize: 12, cursor: 'pointer',
                            }}>Geri Al (tekrar yayına)</button>
                          </div>
                        )}

                        {secili.durum === 'Bekliyor' && (
                          <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Uygulamak için önce "Kabul Et" deyin.</div>
                        )}

                        {uygulamaDurumu && <div style={{ fontSize: 12, marginTop: 8, fontWeight: 600 }}>{uygulamaDurumu}</div>}
                      </div>
                    )}

                    {/* ============ FAZ 3 — YENİ İÇERİK ÜRETİMİ ============
                        Kullanıcı tasarımı (2026-08-18/19): dört parça AYRI AYRI onaylanır.
                        Her parçada üç seçenek — Onaylıyorum / Yeniden oluştur / Bunu kullan.
                        Hepsi onaylanmadan ÜRET açılmaz. */}
                    {(secili.kararTuru === 'YeniOlustur' || secili.kararTuru === 'YeniReklamIcerigi') && (
                      <div style={{
                        border: '1px solid #CFE0D8', borderRadius: 8, marginBottom: 14, overflow: 'hidden',
                      }}>
                        <div style={{
                          padding: '9px 14px', background: '#EAF6F0', borderBottom: '1px solid #CFE0D8',
                          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
                        }}>
                          <span style={{ fontSize: 12, fontWeight: 700, color: '#1D7A56' }}>
                            🎬 Yeni İçerik Üretimi
                          </span>
                          {icerik && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              {/* MEDYA TÜRÜ SEÇİCİ — karar Claude'un değil kullanıcının
                                  (kullanıcı talebi: 2026-08-19). Tür değişince brief baştan
                                  yazılır: görsel kompozisyonu ile video senaryosu farklı şeyler,
                                  eski metni taşımak anlamsız olurdu. */}
                              {['gorsel', 'video'].map(tur => {
                                const secili = icerik.medyaTuru === tur;
                                return (
                                  <button key={tur} disabled={!!icerikDurum} onClick={() => {
                                    if (secili) return;
                                    const ad = tur === 'video' ? 'VİDEO' : 'GÖRSEL';
                                    if (!window.confirm(`Medya türü ${ad} olarak değişecek ve brief baştan yazılacak. Mevcut onaylar sıfırlanır. Devam edilsin mi?`)) return;
                                    setIcerikDurum("Claude brief'i baştan yazıyor...");
                                    icerikMedyaTuru(icerik.id, tur, notlar.MedyaTuru || undefined)
                                      .then(r => { setIcerik(r.data.icerik); setIcerikDurum(''); })
                                      .catch(e => setIcerikDurum('✗ ' + (e.response?.data?.mesaj || e.message)));
                                  }} style={{
                                    border: `1px solid ${secili ? '#1D9E75' : 'var(--border)'}`,
                                    background: secili ? '#DFF3E9' : '#fff',
                                    color: secili ? '#1D7A56' : 'var(--text-muted)',
                                    fontWeight: secili ? 700 : 500,
                                    borderRadius: 5, padding: '3px 10px', fontSize: 11,
                                    cursor: secili || icerikDurum ? 'default' : 'pointer',
                                  }}>{tur === 'video' ? '🎥 video' : '🖼 görsel'}</button>
                                );
                              })}
                              <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                                {icerik.durum}{icerik.revizyonSayisi > 0 ? ` · ${icerik.revizyonSayisi} revizyon` : ''}
                              </span>

                              {/* BRIEF'TEN VAZGEÇ (kullanıcı talebi: 2026-10-02).
                                  "Hiç brief yazılmamış durumuna beni geri döndürecek yolu
                                  bulamadım." Tür değiştirme briefi yeniden yazdırıyor ama
                                  şablon/cinsiyet/ana fikir seçimine geri DÖNDÜRMÜYOR. Bu
                                  düğme briefi reddedip iş emrini üretim öncesi hâline alır;
                                  iş emri silinmez, Kararlar'daki karar da yerinde kalır. */}
                              <button disabled={!!icerikDurum} onClick={() => {
                                if (!window.confirm(
                                  'Bu brief iptal edilecek ve iş emri HİÇ BRIEF YAZILMAMIŞ hâline dönecek.\n\n'
                                  + 'Medya türü, şablon, cinsiyet ve ana fikri baştan seçersin.\n'
                                  + 'İş emri silinmez. Devam edilsin mi?')) return;
                                setIcerikDurum('İptal ediliyor...');
                                icerikBriefIptal(icerik.id)
                                  .then(() => {
                                    setIcerik(null); setIcerikDurum('');
                                    setBriefTur(null); setBriefCinsiyet(''); setAnaFikir('');
                                    setVideoKaynak(null); setSeciliYerlesim(null);
                                    setNotlar({}); setDuzenlenen({}); setAcikParca({});
                                  })
                                  .catch(e => setIcerikDurum('✗ ' + (e.response?.data?.hata || e.response?.data?.mesaj || e.message)));
                              }} style={{
                                border: '1px solid #E0B4B4', background: '#fff', color: '#A33',
                                borderRadius: 5, padding: '3px 10px', fontSize: 11,
                                cursor: icerikDurum ? 'default' : 'pointer',
                              }}>✕ brief&apos;ten vazgeç</button>
                            </div>
                          )}
                        </div>

                        <div style={{ padding: 14 }}>
                          {!icerik && (
                            <div>
                              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 10 }}>
                                Bu iş emri için henüz içerik üretilmedi. Claude, bu hattın gerçek
                                performans verisine ve çalışan görsellerine bakarak bir brief hazırlar.
                              </div>

                              {/* TÜR ÖNCE SEÇİLİR (kullanıcı talebi: 2026-08-19). Brief'in içeriği
                                  türe göre değişiyor — görsel kompozisyonu ile video senaryosu
                                  başka şeyler. Sonradan değiştirmek brief'i baştan yazdırmak demek. */}
                              <div style={{ marginBottom: 12 }}>
                                <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6 }}>
                                  Ne üretilecek?
                                </div>
                                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                  {[
                                    { k: 'resim', kaynak: null, ad: '🖼 Resim reklamı',
                                      not: 'Tek görsel. En ucuz seçenek (~0,40 kredi).' },
                                    { k: 'video', kaynak: 'resim', ad: '🎞 Video — resimden',
                                      not: 'Tek görsel hareketlendirilir, 12 sn video olur (~0,40 kredi).' },
                                    { k: 'video', kaynak: 'video', ad: '🎥 Video — videodan',
                                      not: 'Gerçek video üretilir, hareket doğal olur (~9,6 kredi).' },
                                  ].map(o => {
                                    const anahtar = o.k + (o.kaynak || '');
                                    const secili = (briefTur || 'resim') === anahtar;
                                    return (
                                      <button key={anahtar} title={o.not}
                                        onClick={() => setBriefTur(anahtar)} style={{
                                          border: `1px solid ${secili ? '#1D9E75' : 'var(--border)'}`,
                                          background: secili ? '#DFF3E9' : '#fff',
                                          color: secili ? '#1D7A56' : 'var(--text-muted)',
                                          fontWeight: secili ? 700 : 500, textAlign: 'left',
                                          borderRadius: 7, padding: '8px 12px', fontSize: 12, cursor: 'pointer',
                                          minWidth: 170,
                                        }}>
                                        <div>{o.ad}</div>
                                        <div style={{ fontSize: 10.5, fontWeight: 400, color: 'var(--text-muted)', marginTop: 2 }}>
                                          {o.not}
                                        </div>
                                      </button>
                                    );
                                  })}
                                </div>
                                {(briefTur || 'resim').startsWith('video') && (
                                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6 }}>
                                    Video seçtiğiniz için brief'e seslendirme metni de eklenecek
                                    (en fazla 12 saniyelik konuşma).
                                  </div>
                                )}
                              </div>

                              {/* HASTA / FİZYOTERAPİST ÇİFTİ (kullanıcı talebi: 2026-08-25).
                                  Cinsiyet eşleşmesi zaten zorunlu — kadına kadın, erkeğe erkek;
                                  burada seçilen, hangi çiftin anlatılacağı. Kıyafet kuralı da
                                  buna bağlı: kadın hastada sporcu sütyeni + tayt. */}
                              <div style={{ marginBottom: 12 }}>
                                <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6 }}>
                                  Hasta ve fizyoterapist
                                </div>
                                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                  {[
                                    { k: 'kadin', ad: '👩 Kadın hasta — kadın fizyoterapist',
                                      not: 'Boyun-omuz-sırt bölgesi, sporcu sütyeni ve tayt ile.' },
                                    { k: 'erkek', ad: '👨 Erkek hasta — erkek fizyoterapist',
                                      not: 'Sırt-omuz bölgesi, altta pantolon veya eşofman.' },
                                    { k: '', ad: '🤖 Yapay zeka karar versin',
                                      not: 'Hizmete ve hedef kitleye göre Claude seçer.' },
                                  ].map(o => {
                                    const sec = briefCinsiyet === o.k;
                                    return (
                                      <button key={o.k || 'oto'} title={o.not}
                                        onClick={() => setBriefCinsiyet(o.k)} style={{
                                          border: `1px solid ${sec ? '#1D9E75' : 'var(--border)'}`,
                                          background: sec ? '#DFF3E9' : '#fff',
                                          color: sec ? '#1D7A56' : 'var(--text-muted)',
                                          fontWeight: sec ? 700 : 500, textAlign: 'left',
                                          borderRadius: 7, padding: '8px 12px', fontSize: 12, cursor: 'pointer',
                                          minWidth: 170,
                                        }}>
                                        <div>{o.ad}</div>
                                        <div style={{ fontSize: 10.5, fontWeight: 400, color: 'var(--text-muted)', marginTop: 2 }}>
                                          {o.not}
                                        </div>
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>

                              {/* ANA FİKİR (kullanıcı talebi: 2026-08-25). Boş bırakılırsa sistem
                                  eskisi gibi kendi senaryosunu kurar. Yazılırsa varsayılan klinik
                                  sahnenin YERİNE GEÇER — "yolda yürüyen, beli ağrıyan bir hasta"
                                  denirse tedavi masası sahnesi kurulmaz. */}
                              <div style={{ marginBottom: 12 }}>
                                <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}>
                                  Ana fikir <span style={{ fontWeight: 400, color: 'var(--text-muted)' }}>(isteğe bağlı)</span>
                                </div>
                                <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 5 }}>
                                  Sahnenin çerçevesini siz çizin; yapay zeka senaryoyu bu fikirden kurar.
                                  Boş bırakırsanız kendi senaryosunu yazar.
                                </div>
                                <textarea value={anaFikir} onChange={e2 => setAnaFikir(e2.target.value)}
                                  rows={2} maxLength={1000}
                                  placeholder="Örn: Yolda yürürken beli tutulan bir adam — klinik sahnesi olmasın"
                                  style={{
                                    width: '100%', maxWidth: 620, resize: 'vertical', fontSize: 12.5,
                                    padding: '7px 9px', borderRadius: 6, border: '1px solid var(--border)',
                                    fontFamily: 'inherit',
                                  }} />
                              </div>

                              <button disabled={icerikDurum === 'uretiliyor'} onClick={() => {
                                const s = briefTur || 'resim';
                                setIcerikDurum('uretiliyor');
                                briefUret(secili.id, {
                                  tur: s === 'resim' ? 'resim' : 'video',
                                  kaynak: s === 'videovideo' ? 'video' : 'resim',
                                  cinsiyet: briefCinsiyet || undefined,
                                  anaFikir: anaFikir.trim() || undefined,
                                })
                                  .then(r => { setIcerik(r.data.icerik); setIcerikDurum(''); })
                                  .catch(e => setIcerikDurum('✗ ' + (e.response?.data?.mesaj || e.message)));
                              }} style={{
                                background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 6,
                                padding: '8px 16px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer',
                              }}>{icerikDurum === 'uretiliyor' ? 'Claude yazıyor...' : 'Brief Üret'}</button>

                              {/* Hata mesajının BURADA da görünmesi şart: brief üretilemediğinde
                                  ekranda içerik kartı olmadığı için mesaj hiçbir yere düşmüyordu —
                                  kullanıcı "buton eski haline döndü, ne oldu?" diye kaldı (2026-08-19). */}
                              {icerikDurum && icerikDurum !== 'uretiliyor' && (
                                <div style={{
                                  marginTop: 10, fontSize: 12, fontWeight: 600, padding: '8px 11px',
                                  borderRadius: 6,
                                  background: icerikDurum.startsWith('✗') ? '#FDECEA' : '#EAF1F8',
                                  color: icerikDurum.startsWith('✗') ? '#C0392B' : '#1F6FB2',
                                  border: `1px solid ${icerikDurum.startsWith('✗') ? '#E6A9A2' : '#9FC3E3'}`,
                                }}>{icerikDurum}</div>
                              )}
                            </div>
                          )}

                          {icerik && (
                            <>
                              <div style={{ marginBottom: 12 }}>
                                <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 2 }}>KONSEPT</div>
                                <div style={{ fontSize: 13, fontWeight: 600 }}>{icerik.konsept}</div>
                                {icerik.nedenFarkli && (
                                  <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 4, whiteSpace: 'pre-wrap' }}>
                                    {icerik.nedenFarkli}
                                  </div>
                                )}
                              </div>

                              {[
                                { k: 'UretimIstemi', p: icerik.parcalar.uretimIstemi,
                                  ad: icerik.medyaTuru === 'video' ? '1 · Video senaryosu' : '1 · Görsel kompozisyonu',
                                  not: 'Üretime bu metin gidecek. Görselde hiçbir yazı olmayacak.' },
                                { k: 'UstMetin', p: icerik.parcalar.ustMetin,
                                  ad: icerik.medyaTuru === 'video' ? '2 · Video üstü metin' : '2 · Görsel üstü metin',
                                  not: 'Görsel üretimine gitmez — şablona yazı olarak basılır.' },
                                ...(icerik.medyaTuru === 'video' ? [{
                                  k: 'Seslendirme', p: icerik.parcalar.seslendirme,
                                  ad: '3 · Seslendirme metni',
                                  not: `Ses: ${icerik.parcalar.seslendirme.ses || '-'} — ${icerik.parcalar.seslendirme.sesGerekce || ''}` }] : []),
                                { k: 'BirincilMetin', p: icerik.parcalar.birincilMetin,
                                  ad: '4 · Reklamın ÜSTÜNDEKİ metin', not: 'Meta: birincil metin' },
                                { k: 'Baslik', p: icerik.parcalar.baslik,
                                  ad: '5 · Reklamın ALTINDAKİ başlık', not: 'Meta: başlık (butonun yanı)' },
                              ].map(({ k, p, ad, not }) => (
                                <div key={k} style={{
                                  border: `1px solid ${p.onay ? '#BFE3D2' : 'var(--border)'}`,
                                  background: p.onay ? '#F4FBF8' : '#fff',
                                  borderRadius: 7, padding: 11, marginBottom: 9,
                                }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 5 }}>
                                    <span style={{ fontSize: 12, fontWeight: 700 }}>{ad}</span>
                                    <span style={{
                                      fontSize: 10.5, fontWeight: 700, padding: '2px 8px', borderRadius: 999,
                                      background: p.onay ? '#DFF3E9' : '#FFF6E5',
                                      color: p.onay ? '#1D7A56' : '#B8860B',
                                    }}>{p.onay ? '✓ ONAYLANDI' : 'ONAY BEKLİYOR'}</span>
                                  </div>
                                  <div style={{ fontSize: 10.5, color: 'var(--text-muted)', marginBottom: 6 }}>{not}</div>

                                  <div style={{
                                    background: '#FAFBFB', border: '1px solid var(--border)', borderRadius: 6,
                                    padding: '9px 11px', fontSize: 12.5, lineHeight: 1.6, whiteSpace: 'pre-wrap',
                                    marginBottom: 8,
                                  }}>{p.deger || '—'}</div>

                                  {(!p.onay || acikParca[k]) && (
                                    <>
                                      <textarea rows={2} placeholder="Değişiklik isteğiniz (Yeniden oluştur için) veya kendi metniniz (Bunu kullan için)"
                                        value={duzenlenen[k] !== undefined ? duzenlenen[k] : (notlar[k] || '')}
                                        onChange={e => { setNotlar(n => ({ ...n, [k]: e.target.value })); setDuzenlenen(d => ({ ...d, [k]: e.target.value })); }}
                                        style={{
                                          width: '100%', padding: '7px 9px', fontSize: 12,
                                          border: '1px solid var(--border)', borderRadius: 6, resize: 'vertical', marginBottom: 7,
                                        }} />

                                      {/* ÇERÇEVE, tam da senaryo isteminin belirlendiği yerde
                                          (kullanıcı talebi: 2026-08-25). Metne dokunmaz; "Yeniden
                                          oluştur" dendiğinde notunuzla birlikte Claude'a gider.
                                          Yalnızca senaryo/kompozisyon parçasında gösterilir —
                                          başlık veya açıklama yazarken cinsiyetin anlamı yok. */}
                                      {k === 'UretimIstemi' && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
                                          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Hasta ve fizyoterapist:</span>
                                          {[
                                            { v: 'kadin', ad: '👩 Kadın — kadın' },
                                            { v: 'erkek', ad: '👨 Erkek — erkek' },
                                            { v: '', ad: '🤖 Yapay zeka seçsin' },
                                          ].map(o => {
                                            const sec = (icerik.cinsiyet || '') === o.v;
                                            return (
                                              <button key={o.v || 'oto'} disabled={!!islenenParca}
                                                title="Yeniden oluştururken uygulanır; mevcut metni değiştirmez"
                                                onClick={() => cerceveDegistir(o.v)} style={{
                                                  border: `1px solid ${sec ? '#1D9E75' : 'var(--border)'}`,
                                                  background: sec ? '#DFF3E9' : '#fff',
                                                  color: sec ? '#1D7A56' : 'var(--text-muted)',
                                                  fontWeight: sec ? 700 : 500,
                                                  borderRadius: 5, padding: '4px 10px', fontSize: 11.5,
                                                  cursor: islenenParca ? 'default' : 'pointer',
                                                }}>{o.ad}</button>
                                            );
                                          })}
                                          {cerceveDurum && (
                                            <span style={{
                                              fontSize: 10.5, fontWeight: 600,
                                              color: cerceveDurum.startsWith('✗') ? '#C0392B' : '#1D7A56',
                                            }}>{cerceveDurum}</span>
                                          )}
                                        </div>
                                      )}

                                      <div style={{ display: 'flex', gap: 7, flexWrap: 'wrap' }}>
                                        <button disabled={!!islenenParca} onClick={() => parcaEylem(k, 'Onayla')} style={{
                                          background: islenenParca ? '#E4E9EA' : '#1D9E75',
                                          color: islenenParca ? '#9AA7AC' : '#fff', border: 'none', borderRadius: 5,
                                          padding: '5px 12px', fontSize: 11.5, fontWeight: 600,
                                          cursor: islenenParca ? 'default' : 'pointer',
                                        }}>Onaylıyorum</button>
                                        <button disabled={!!islenenParca} onClick={() => parcaEylem(k, 'YenidenUret')} style={{
                                          background: '#fff',
                                          color: islenenParca ? '#9AA7AC' : '#1F6FB2',
                                          border: `1px solid ${islenenParca ? 'var(--border)' : '#1F6FB2'}`,
                                          borderRadius: 5, padding: '5px 12px', fontSize: 11.5, fontWeight: 600,
                                          cursor: islenenParca ? 'default' : 'pointer',
                                        }}>{islenenParca === k && islenenEylem === 'YenidenUret' ? 'Claude yazıyor...' : 'Yeniden oluştur'}</button>
                                        <button disabled={!duzenlenen[k]} onClick={() => parcaEylem(k, 'BunuKullan')} style={{
                                          background: '#fff', color: duzenlenen[k] ? '#B8860B' : '#B9C2C6',
                                          border: `1px solid ${duzenlenen[k] ? '#B8860B' : 'var(--border)'}`, borderRadius: 5,
                                          padding: '5px 12px', fontSize: 11.5, fontWeight: 600,
                                          cursor: duzenlenen[k] ? 'pointer' : 'default',
                                        }}>Bunu kullan</button>
                                      </div>
                                    </>
                                  )}

                                  {/* Onaylanmış parçayı yeniden açar. Eskiden bu düğme notsuz
                                      yeniden üretim başlatıyordu — kullanıcı görüşünü yazamıyordu
                                      (2026-08-19 tespiti). Artık düzenleme alanını açıyor. */}
                                  {/* KENDİ RESMİMİ KULLAN (kullanıcı talebi: 2026-08-22).
                                      Yalnızca görsel üretilen akışlarda anlamlı: resim reklamı
                                      veya resimden video. Yüklenirse TopView'a hiç gidilmez. */}
                                  {k === 'UretimIstemi'
                                    && (icerik.medyaTuru !== 'video' || (videoKaynak || icerik.videoKaynak || 'resim') === 'resim') && (
                                    <div style={{
                                      marginTop: 8, padding: '9px 11px', borderRadius: 6,
                                      background: icerik.kendiGorsel ? '#EAF6F0' : '#FAFBFB',
                                      border: `1px solid ${icerik.kendiGorsel ? '#9FD3BB' : 'var(--border)'}`,
                                    }}>
                                      {icerik.kendiGorsel ? (
                                        <>
                                          <div style={{ fontSize: 11.5, fontWeight: 700, color: '#1D7A56', marginBottom: 6 }}>
                                            ✓ Kendi görseliniz kullanılacak — yapay zeka görsel üretmeyecek
                                          </div>
                                          {icerik.uretilen?.baglanti && (
                                            <img src={tazeAdres(icerik.uretilen.baglanti, (icerik.renderId || icerik.guncellemeZamani))} alt="Yüklenen görsel"
                                              style={{ maxWidth: 160, borderRadius: 5, display: 'block', marginBottom: 6 }} />
                                          )}
                                          <button onClick={() => {
                                            if (!window.confirm('Yüklediğiniz görselden vazgeçilsin mi? Üretim yapay zekaya döner.')) return;
                                            kendiGorselimIptal(icerik.id)
                                              .then(r => setIcerik(r.data.icerik))
                                              .catch(e2 => setIcerikDurum('✗ ' + (e2.response?.data?.hata || e2.message)));
                                          }} style={{
                                            background: 'none', border: 'none', color: '#C0392B', fontSize: 11,
                                            cursor: 'pointer', padding: 0, textDecoration: 'underline',
                                          }}>vazgeç, yapay zeka üretsin</button>
                                        </>
                                      ) : (
                                        <>
                                          <div style={{ fontSize: 11.5, fontWeight: 600, marginBottom: 5 }}>
                                            Ya da kendi resminizi kullanın
                                          </div>
                                          <div style={{ fontSize: 10.5, color: 'var(--text-muted)', marginBottom: 6 }}>
                                            Yüklerseniz yapay zeka görsel üretmez, kredi harcanmaz —
                                            dosyanız doğrudan şablona girer. Yazısız olması iyi olur, metinler şablonda basılıyor.
                                          </div>
                                          <input type="file" accept="image/jpeg,image/png" disabled={gorselYukleniyor}
                                            onChange={e2 => {
                                              const d = e2.target.files && e2.target.files[0];
                                              if (!d) return;
                                              setGorselYukleniyor(true);
                                              setIcerikDurum('Görsel yükleniyor...');
                                              kendiGorselimYukle(icerik.id, d)
                                                .then(r => { setIcerik(r.data.icerik); setIcerikDurum('✓ Görseliniz yüklendi.'); })
                                                .catch(er => setIcerikDurum('✗ ' + (er.response?.data?.hata || er.message)))
                                                .finally(() => { setGorselYukleniyor(false); e2.target.value = ''; });
                                            }} style={{ fontSize: 11.5 }} />
                                        </>
                                      )}
                                    </div>
                                  )}

                                  {islenenParca === k && (
                                    <div style={{
                                      fontSize: 11.5, fontWeight: 600, color: '#1F6FB2', marginTop: 6,
                                      background: '#EAF1F8', border: '1px solid #9FC3E3',
                                      borderRadius: 5, padding: '6px 10px',
                                    }}>{islenenEylem === 'YenidenUret'
                                        ? 'Claude bu bölümü yeniden yazıyor — 20-40 saniye sürebilir...'
                                        : 'Kaydediliyor...'}</div>
                                  )}

                                  {p.onay && !acikParca[k] && (
                                    <button onClick={() => setAcikParca(a => ({ ...a, [k]: true }))} style={{
                                      background: 'none', border: 'none', color: '#1F6FB2', fontSize: 11,
                                      cursor: 'pointer', padding: 0, textDecoration: 'underline',
                                    }}>tekrar değiştir</button>
                                  )}
                                </div>
                              ))}

                              {icerik.kacinilanlar && (
                                <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginBottom: 10 }}>
                                  <strong>Kaçınılanlar:</strong> {icerik.kacinilanlar}
                                </div>
                              )}

                              {icerikDurum && (
                                <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8,
                                              color: icerikDurum.startsWith('✗') ? '#C0392B' : '#1F6FB2' }}>{icerikDurum}</div>
                              )}

                              {/* Üretim çıktısı: dosya HAM haldedir — üzerinde yazı yoktur.
                                  Metinler şablonda basılıyor; bu dosya yalnızca kaynak. */}
                              {(icerik.uretilen?.gorsel || icerik.uretilen?.video) && (
                                <div style={{
                                  border: '1px solid #BFE3D2', background: '#F4FBF8',
                                  borderRadius: 7, padding: 11, marginBottom: 10,
                                }}>
                                  <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 7 }}>
                                    Ham {icerik.uretilen.video ? 'video' : 'görsel'} — yazısız, şablona giren hali
                                  </div>

                                  {icerik.uretilen.gorsel && (
                                    <img src={tazeAdres(icerik.uretilen.baglanti, (icerik.renderId || icerik.guncellemeZamani))} alt="Üretilen görsel"
                                      style={{ maxWidth: 320, width: '100%', borderRadius: 6, display: 'block', marginBottom: 8 }} />
                                  )}
                                  {icerik.uretilen.video && (
                                    <video src={tazeAdres(icerik.uretilen.baglanti, (icerik.renderId || icerik.guncellemeZamani))} controls
                                      style={{ maxWidth: 320, width: '100%', borderRadius: 6, display: 'block', marginBottom: 8 }} />
                                  )}

                                  <a href={tazeAdres(icerik.uretilen.baglanti, (icerik.renderId || icerik.guncellemeZamani))} target="_blank" rel="noreferrer"
                                    style={{ fontSize: 11.5, fontWeight: 600, color: '#1F6FB2' }}>
                                    Dosyayı yeni sekmede aç / indir
                                  </a>
                                  {/* FİNAL DOSYA — metinler artık Creatomate şablonunda basılıyor,
                                      elle dosya hazırlanmıyor (2026-08-19). */}
                                  {icerik.finalBaglanti && (
                                    <div style={{ marginTop: 12, paddingTop: 10, borderTop: '1px solid #BFE3D2' }}>
                                      <div style={{ fontSize: 12.5, fontWeight: 700, color: '#1D7A56', marginBottom: 7 }}>
                                        ✓ Yayına hazır dosya — şablondan üretildi
                                        {icerik.sesSaniye ? ` · seslendirme ${icerik.sesSaniye} sn` : ''}
                                      </div>
                                      {icerik.medyaTuru === 'video' ? (
                                        <video src={tazeAdres(icerik.finalBaglanti, (icerik.renderId || icerik.guncellemeZamani))} controls
                                          style={{ maxWidth: 320, width: '100%', borderRadius: 6, display: 'block', marginBottom: 8 }} />
                                      ) : (
                                        <img src={tazeAdres(icerik.finalBaglanti, (icerik.renderId || icerik.guncellemeZamani))} alt="Final dosya"
                                          style={{ maxWidth: 320, width: '100%', borderRadius: 6, display: 'block', marginBottom: 8 }} />
                                      )}
                                      <a href={tazeAdres(icerik.finalBaglanti, (icerik.renderId || icerik.guncellemeZamani))} target="_blank" rel="noreferrer"
                                        style={{ fontSize: 11.5, fontWeight: 600, color: '#1F6FB2' }}>
                                        Final dosyayı indir
                                      </a>
                                      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6 }}>
                                        Beğenmezseniz ÜRET'e tekrar basın; yeni bir varyasyon üretilir.
                                      </div>
                                    </div>
                                  )}

                                  {/* Elle final yükleme KALDIRILDI (2026-08-19): final artık
                                      Creatomate şablonundan geliyor, kullanıcı dosya hazırlamıyor. */}
                                  <div style={{ marginTop: 10, paddingTop: 10, borderTop: '1px dashed #BFE3D2' }}>

                                    {/* YAYINLA: aynı sete YENİ reklam açar, mevcut reklamlara dokunmaz. */}
                                    {icerik.finalBaglanti && !icerik.metaReklamId && (
                                      <div style={{ marginTop: 12, paddingTop: 10, borderTop: '1px solid #BFE3D2' }}>
                                        {/* Hedef set belli degilse once secim istenir (2026-08-20). */}
                                        {yayinOnizleme && yayinOnizleme.setSecimiGerekli ? (
                                          <div style={{ marginBottom: 10 }}>
                                            <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6 }}>
                                              Bu iş emri kampanya seviyesinde — reklam hangi sete açılsın?
                                            </div>
                                            <select value={seciliSet || ''} onChange={e2 => setSeciliSet(e2.target.value)} style={{
                                              padding: '6px 9px', fontSize: 12.5, borderRadius: 6,
                                              border: '1px solid var(--border)', minWidth: 260, marginRight: 8,
                                            }}>
                                              <option value="">— set seçin —</option>
                                              {(yayinOnizleme.setler || []).map(st => (
                                                <option key={st.id} value={st.id}>
                                                  {st.ad}{st.gunlukButceKurus ? ` (${(st.gunlukButceKurus / 100).toLocaleString('tr-TR')} ₺/gün)` : ''}
                                                </option>
                                              ))}
                                            </select>
                                            <button disabled={!seciliSet} onClick={() => {
                                              setIcerikDurum('Yayın bilgileri okunuyor...');
                                              icerikYayinOnizleme(icerik.id, seciliSet)
                                                .then(r => { setYayinOnizleme(r.data); setIcerikDurum(''); })
                                                .catch(er => setIcerikDurum('✗ ' + (er.response?.data?.mesaj || er.message)));
                                            }} style={{
                                              background: seciliSet ? '#1F6FB2' : '#E4E9EA',
                                              color: seciliSet ? '#fff' : '#9AA7AC', border: 'none', borderRadius: 5,
                                              padding: '6px 12px', fontSize: 11.5, fontWeight: 600,
                                              cursor: seciliSet ? 'pointer' : 'default',
                                            }}>Devam</button>
                                          </div>
                                        ) : yayinOnizleme ? (
                                          <div style={{ fontSize: 11.5, color: 'var(--text-muted)', lineHeight: 1.7, marginBottom: 8 }}>
                                            <div><strong>Hedef set:</strong> {yayinOnizleme.set.kampanya} › {yayinOnizleme.set.ad}</div>
                                            <div><strong>Lead formu:</strong> {yayinOnizleme.leadFormId} · <strong>buton:</strong> {yayinOnizleme.buton}</div>
                                            <div>Bu bilgiler setteki mevcut reklamdan kopyalandı — yeni reklam aynı forma bağlanacak.</div>
                                          </div>
                                        ) : (
                                          <button onClick={() => {
                                            setIcerikDurum('Yayın bilgileri okunuyor...');
                                            icerikYayinOnizleme(icerik.id, seciliSet)
                                              .then(r => { setYayinOnizleme(r.data); setIcerikDurum(''); })
                                              .catch(e => setIcerikDurum('✗ ' + (e.response?.data?.mesaj || e.message)));
                                          }} style={{
                                            background: '#fff', color: '#1F6FB2', border: '1px solid #1F6FB2',
                                            borderRadius: 5, padding: '5px 12px', fontSize: 11.5, fontWeight: 600,
                                            cursor: 'pointer', marginBottom: 8,
                                          }}>Nereye yayınlanacak?</button>
                                        )}

                                        <button disabled={yayinlaniyor} onClick={() => {
                                          if (!window.confirm(
                                            'Yeni reklam CANLI olarak açılsın mı?\n\n' +
                                            (yayinOnizleme ? `Set: ${yayinOnizleme.set.ad}\n` : '') +
                                            'Reklam ACTIVE açılır ve para harcamaya başlar. Mevcut reklamlara dokunulmaz.'
                                          )) return;
                                          setYayinlaniyor(true);
                                          setIcerikDurum('Meta\'ya yükleniyor ve reklam açılıyor...');
                                          icerikYayinla(icerik.id, seciliSet)
                                            .then(r => {
                                              setIcerik(r.data.icerik);
                                              setIcerikDurum(`✓ Yayınlandı — reklam ${r.data.yayin.reklamId}`);
                                              oneriDetay(secili.id).then(o => setSecili(o.data)).catch(() => {});
                                              // META İNCELEMESİ BİTENE KADAR DURUMU İZLE (2026-08-21).
                                              // Yayın anındaki durum "Meta tarafında hazırlanıyor" oluyor;
                                              // kullanıcı rozetin değişmesini boşuna bekliyordu. 15 saniyede
                                              // bir sorar, sonuçlanınca ya da 5 dakikada kendiliğinden durur.
                                              let tur = 0;
                                              const izle = setInterval(() => {
                                                tur += 1;
                                                icerikYayinDurumu(icerik.id)
                                                  .then(d => {
                                                    setYayinDurumu(d.data);
                                                    const bitti = d.data.gercekDurum === 'ACTIVE'
                                                      || d.data.gercekDurum === 'DISAPPROVED'
                                                      || d.data.durum === 'PAUSED';
                                                    if (bitti || tur >= 20) clearInterval(izle);
                                                  })
                                                  .catch(() => clearInterval(izle));
                                              }, 15000);
                                            })
                                            .catch(e => setIcerikDurum('✗ ' + (e.response?.data?.mesaj || e.response?.data?.hata || e.message)))
                                            .finally(() => setYayinlaniyor(false));
                                        }} style={{
                                          background: yayinlaniyor ? '#E4E9EA' : '#1F6FB2',
                                          color: yayinlaniyor ? '#9AA7AC' : '#fff',
                                          border: 'none', borderRadius: 6, padding: '8px 20px',
                                          fontSize: 13, fontWeight: 700, cursor: yayinlaniyor ? 'default' : 'pointer',
                                        }}>{yayinlaniyor ? 'YAYINLANIYOR...' : 'YAYINLA'}</button>
                                      </div>
                                    )}

                                    {icerik.metaReklamId && (
                                      <div style={{ marginTop: 12, paddingTop: 10, borderTop: '1px solid #BFE3D2' }}>
                                        <div style={{ fontSize: 12, fontWeight: 700, color: '#1D7A56', marginBottom: 6 }}>
                                          {/* AD VE SET META'DAN OKUNUR (2026-08-31): reklam Meta'da yeniden
                                              adlandırılabilir ya da başka sete taşınabilir (ör. ŞÜKRÜ ÖZEL seti);
                                              kimlik numarası ezberlemek yerine güncel adı görün. Durum henüz
                                              okunmadıysa kimliğe düşer. */}
                                          ✓ Yayında — {yayinDurumu?.reklamAdi || ('reklam ' + icerik.metaReklamId)}
                                          {yayinDurumu?.setAdi ? ' · set: ' + yayinDurumu.setAdi : ''}
                                          {' '}({tarihFormat(icerik.yayinZamani)})
                                        </div>

                                        {/* Reklamı BU EKRANDA göster. fb.me bağlantısı Facebook'ta
                                            "reklamı göstermek istiyor" ekranına düşürüyordu. */}
                                        <div style={{ marginBottom: 10 }}>
                                          <button onClick={() => {
                                            setIcerikDurum('Önizlemeler Meta\'dan alınıyor...');
                                            icerikOnizlemeler(icerik.id)
                                              .then(r => {
                                                setOnizlemeler(r.data.onizlemeler);
                                                setSeciliYerlesim(r.data.onizlemeler[0]?.yerlesim);
                                                setIcerikDurum('');
                                              })
                                              .catch(e => setIcerikDurum('✗ ' + (e.response?.data?.hata || e.message)));
                                          }} style={{
                                            background: '#1F6FB2', color: '#fff', border: 'none', borderRadius: 5,
                                            padding: '6px 14px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer',
                                          }}>🔍 Reklamı burada göster</button>

                                          {onizlemeler.length > 0 && (
                                            <div style={{ marginTop: 10 }}>
                                              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
                                                {onizlemeler.map(o => (
                                                  <button key={o.yerlesim} onClick={() => setSeciliYerlesim(o.yerlesim)} style={{
                                                    border: `1px solid ${seciliYerlesim === o.yerlesim ? '#1F6FB2' : 'var(--border)'}`,
                                                    background: seciliYerlesim === o.yerlesim ? '#EAF1F8' : '#fff',
                                                    color: seciliYerlesim === o.yerlesim ? '#1F6FB2' : 'var(--text-muted)',
                                                    fontWeight: seciliYerlesim === o.yerlesim ? 700 : 500,
                                                    borderRadius: 5, padding: '4px 10px', fontSize: 11, cursor: 'pointer',
                                                  }}>{o.ad}</button>
                                                ))}
                                              </div>
                                              {onizlemeler.filter(o => o.yerlesim === seciliYerlesim).map(o => (
                                                <iframe key={o.yerlesim} src={o.adres} title={o.ad}
                                                  style={{
                                                    width: '100%', maxWidth: 420, height: 640, border: '1px solid var(--border)',
                                                    borderRadius: 8, background: '#fff',
                                                  }} />
                                              ))}
                                            </div>
                                          )}
                                        </div>

                                        {/* Facebook'un paylaşılabilir bağlantısı — yedek yol. */}
                                        <div style={{ marginBottom: 8 }}>
                                          {icerik.onizlemeBaglantisi ? (
                                            <a href={icerik.onizlemeBaglantisi} target="_blank" rel="noreferrer" style={{
                                              fontSize: 11, color: 'var(--text-muted)', textDecoration: 'underline',
                                            }}>Facebook'un kendi önizleme sayfasında aç</a>
                                          ) : (
                                            <button onClick={() => {
                                              setIcerikDurum('Önizleme bağlantısı isteniyor...');
                                              icerikOnizlemeTazele(icerik.id)
                                                .then(r => { setIcerik(r.data.icerik); setIcerikDurum(''); })
                                                .catch(e => setIcerikDurum('✗ ' + (e.response?.data?.hata || e.message)));
                                            }} style={{
                                              background: '#fff', color: '#1F6FB2', border: '1px solid #1F6FB2',
                                              borderRadius: 5, padding: '5px 12px', fontSize: 11.5, fontWeight: 600, cursor: 'pointer',
                                            }}>Önizleme bağlantısını al</button>
                                          )}
                                        </div>

                                        {/* Durum Meta'dan okunur — "durdu mu yayında mı" belirsizliği
                                            kullanıcı şikâyetiydi (2026-08-19). */}
                                        {yayinDurumu && (
                                          <div style={{
                                            display: 'inline-block', marginBottom: 8, padding: '4px 10px', borderRadius: 999,
                                            fontSize: 11.5, fontWeight: 700,
                                            // DURMUS REKLAM SARI DEGIL KIRMIZI (2026-08-31): reklam ACTIVE olsa da
                                            // seti/kampanyasi kapaliysa gosterim almiyor; sari "bekleniyor" rengi
                                            // kullaniciya her sey yolundaymis izlenimi veriyordu.
                                            background: yayinDurumu.gercekDurum === 'ACTIVE' ? '#EAF6F0'
                                                      : ['PAUSED'].includes(yayinDurumu.durum)
                                                        || ['ADSET_PAUSED', 'CAMPAIGN_PAUSED', 'DISAPPROVED', 'ARCHIVED', 'DELETED']
                                                          .includes(yayinDurumu.gercekDurum)
                                                        ? '#FDECEA' : '#FFF6E5',
                                            color: yayinDurumu.gercekDurum === 'ACTIVE' ? '#1D7A56'
                                                 : ['PAUSED'].includes(yayinDurumu.durum)
                                                   || ['ADSET_PAUSED', 'CAMPAIGN_PAUSED', 'DISAPPROVED', 'ARCHIVED', 'DELETED']
                                                     .includes(yayinDurumu.gercekDurum)
                                                   ? '#C0392B' : '#8A6D1F',
                                          }}>
                                            {yayinDurumu.gercekDurum === 'ACTIVE' ? '● '
                                              : ['PAUSED'].includes(yayinDurumu.durum)
                                                || ['ADSET_PAUSED', 'CAMPAIGN_PAUSED', 'DISAPPROVED', 'ARCHIVED', 'DELETED']
                                                  .includes(yayinDurumu.gercekDurum)
                                                ? '⏸ ' : '⏳ '}
                                            {yayinDurumu.aciklama}
                                          </div>
                                        )}

                                        {/* KİM DURDURDU (kullanıcı talebi: 2026-08-31). Meta gerekçe
                                            tutmuyor; etkinlik kaydında yalnızca kişi ve zaman var.
                                            Kullanıcı bunu sormak için Meta paneline gidiyordu. */}
                                        {yayinDurumu?.sonDegisiklik && (
                                          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 8 }}>
                                            Son değişiklik: <strong>{yayinDurumu.sonDegisiklik.kisi || 'bilinmiyor'}</strong>
                                            {' '}· {yayinDurumu.sonDegisiklik.katman}
                                            {yayinDurumu.sonDegisiklik.eski && yayinDurumu.sonDegisiklik.yeni
                                              ? ` · ${yayinDurumu.sonDegisiklik.eski} → ${yayinDurumu.sonDegisiklik.yeni}`
                                              : ''}
                                            {yayinDurumu.sonDegisiklik.zaman
                                              ? ` · ${new Date(yayinDurumu.sonDegisiklik.zaman).toLocaleString('tr-TR')}`
                                              : ''}
                                          </div>
                                        )}

                                        {/* PERFORMANS ÖZETİ — "yayınladım, sonra ne oldu?" sorusu
                                            ekranda cevaplansın diye (kullanıcı: 2026-08-31). */}
                                        {yayinDurumu?.performans && (
                                          <div style={{
                                            display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 8,
                                            padding: '7px 11px', borderRadius: 6,
                                            background: '#F7F9FA', border: '1px solid var(--border)',
                                          }}>
                                            {[
                                              { ad: 'Harcama', d: `${(yayinDurumu.performans.harcama || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺` },
                                              { ad: 'Gösterim', d: (yayinDurumu.performans.gosterim || 0).toLocaleString('tr-TR') },
                                              { ad: 'Tık', d: (yayinDurumu.performans.tik || 0).toLocaleString('tr-TR') },
                                              { ad: 'CTR', d: `%${(yayinDurumu.performans.ctr || 0).toLocaleString('tr-TR')}` },
                                              { ad: 'Lead', d: (yayinDurumu.performans.lead || 0).toLocaleString('tr-TR'), vurgu: true },
                                              // Lead başı maliyet yalnızca lead varsa anlamlı.
                                              ...(yayinDurumu.performans.lead > 0 ? [{
                                                ad: 'Lead başı',
                                                d: `${(yayinDurumu.performans.harcama / yayinDurumu.performans.lead).toLocaleString('tr-TR', { maximumFractionDigits: 0 })} ₺`,
                                              }] : []),
                                            ].map(x => (
                                              <div key={x.ad}>
                                                <div style={{ fontSize: 10, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.3px' }}>
                                                  {x.ad}
                                                </div>
                                                <div style={{ fontSize: 13, fontWeight: 700, color: x.vurgu ? '#1D7A56' : 'var(--text)' }}>
                                                  {x.d}
                                                </div>
                                              </div>
                                            ))}
                                            {yayinDurumu.performans.gosterim === 0 && (
                                              <div style={{ fontSize: 11, color: 'var(--text-muted)', alignSelf: 'center' }}>
                                                Henüz hiç gösterim almadı.
                                              </div>
                                            )}
                                          </div>
                                        )}

                                        <div style={{ display: 'flex', gap: 7, flexWrap: 'wrap' }}>
                                          {yayinDurumu?.durum === 'PAUSED' ? (
                                            <button onClick={() => {
                                              if (!window.confirm('Reklam tekrar yayına alınsın mı? (ACTIVE)')) return;
                                              setIcerikDurum('Yayına alınıyor...');
                                              icerikYayiniBaslat(icerik.id)
                                                .then(r => {
                                                  setIcerik(r.data.icerik); setYayinDurumu(r.data.yayinDurumu);
                                                  setIcerikDurum('✓ Reklam yayına alındı.');
                                                })
                                                .catch(e => setIcerikDurum('✗ ' + (e.response?.data?.mesaj || e.message)));
                                            }} style={{
                                              background: '#1D9E75', color: '#fff', border: 'none',
                                              borderRadius: 5, padding: '5px 12px', fontSize: 11.5, fontWeight: 600, cursor: 'pointer',
                                            }}>Tekrar yayına al</button>
                                          ) : (
                                            <button onClick={() => {
                                              if (!window.confirm('Bu reklam durdurulsun mu? (PAUSED)')) return;
                                              setIcerikDurum('Durduruluyor...');
                                              icerikYayiniDurdur(icerik.id)
                                                .then(r => {
                                                  setIcerik(r.data.icerik); setYayinDurumu(r.data.yayinDurumu);
                                                  setIcerikDurum('✓ Reklam durduruldu.');
                                                })
                                                .catch(e => setIcerikDurum('✗ ' + (e.response?.data?.mesaj || e.message)));
                                            }} style={{
                                              background: '#fff', color: '#C0392B', border: '1px solid #C0392B',
                                              borderRadius: 5, padding: '5px 12px', fontSize: 11.5, fontWeight: 600, cursor: 'pointer',
                                            }}>Reklamı durdur</button>
                                          )}

                                          <button onClick={() => {
                                            setIcerikDurum('Durum Meta\'dan okunuyor...');
                                            icerikYayinDurumu(icerik.id)
                                              .then(r => { setYayinDurumu(r.data); setIcerikDurum(''); })
                                              .catch(e => setIcerikDurum('✗ ' + (e.response?.data?.hata || e.message)));
                                          }} style={{
                                            background: 'none', border: 'none', color: '#1F6FB2', fontSize: 11,
                                            cursor: 'pointer', padding: 0, textDecoration: 'underline',
                                          }}>durumu yenile</button>

                                          {/* PERFORMANS — "bu reklam işe yaradı mı?" (2026-08-31).
                                              Meta rakamları tek başına cevap vermiyor: asıl soru kaç lead,
                                              kaç randevu, kaç lira ciro. Klinik veritabanları taranacağı
                                              için birkaç saniye sürer. */}
                                          <button onClick={() => {
                                            setRaporHata(''); setRaporYukleniyor(true); setRapor(null);
                                            icerikPerformans(icerik.id)
                                              .then(r => setRapor(r.data))
                                              .catch(e => setRaporHata(e.response?.data?.hata || e.message))
                                              .finally(() => setRaporYukleniyor(false));
                                          }} disabled={raporYukleniyor} style={{
                                            background: raporYukleniyor ? '#E4E9EA' : '#1F6FB2',
                                            color: raporYukleniyor ? '#9AA7AC' : '#fff',
                                            border: 'none', borderRadius: 5, padding: '5px 12px',
                                            fontSize: 11.5, fontWeight: 700,
                                            cursor: raporYukleniyor ? 'default' : 'pointer', marginLeft: 10,
                                          }}>{raporYukleniyor ? 'HESAPLANIYOR...' : '📊 PERFORMANS'}</button>
                                          {raporHata && (
                                            <span style={{ fontSize: 11, color: '#C0392B', marginLeft: 8 }}>✗ {raporHata}</span>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}

                              {/* ÜÇ AŞAMALI ÜRETİM (kullanıcı tasarımı: 2026-08-25).
                                  Her aşama ayrı üretilir ve ayrı yenilenir; beğenmediğiniz
                                  aşama için diğer iki yapay zekaya tekrar para ödenmez. */}
                              <div style={{ paddingTop: 10, borderTop: '1px solid var(--border)' }}>
                                {!icerik.uretimeHazir ? (
                                  <div style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>
                                    Tüm parçalar onaylanmadan üretim başlamaz.
                                  </div>
                                ) : (
                                  <>
                                    {/* 1. AŞAMA — GÖRSEL / VİDEO (TopView) */}
                                    <div style={asamaKutu(icerik.medyaHazir)}>
                                      <div style={asamaBaslik}>
                                        <span>1 · {icerik.medyaTuru === 'video' ? 'Video' : 'Görsel'}</span>
                                        {icerik.medyaHazir && <span style={rozet}>✓ hazır</span>}
                                        {icerik.kendiGorsel && (
                                          <span style={{ fontSize: 10.5, fontWeight: 500, color: 'var(--text-muted)' }}>
                                            kendi görseliniz
                                          </span>
                                        )}
                                      </div>

                                      {/* Video neyden üretilsin — brief'i değiştirmez, sadece maliyeti. */}
                                      {icerik.medyaTuru === 'video' && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 7, flexWrap: 'wrap' }}>
                                          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Neyden üretilsin:</span>
                                          {[
                                            { k: 'resim', ad: 'Resimden', not: 'ucuz — tek görsel hareketlendirilir' },
                                            { k: 'video', ad: 'Videodan', not: 'gerçek video üretilir, ~24 kat pahalı' },
                                          ].map(o => {
                                            const sec = (videoKaynak || icerik.videoKaynak || 'resim') === o.k;
                                            return (
                                              <button key={o.k} title={o.not} onClick={() => setVideoKaynak(o.k)} style={{
                                                border: `1px solid ${sec ? '#1F6FB2' : 'var(--border)'}`,
                                                background: sec ? '#EAF1F8' : '#fff',
                                                color: sec ? '#1F6FB2' : 'var(--text-muted)',
                                                fontWeight: sec ? 700 : 500,
                                                borderRadius: 5, padding: '3px 10px', fontSize: 11, cursor: 'pointer',
                                              }}>{o.ad}</button>
                                            );
                                          })}
                                        </div>
                                      )}

                                      <button disabled={!!asamaDurum.asama} onClick={() => asamaCalistir('medya')}
                                        style={asamaDugmesi(icerik.medyaHazir, !!asamaDurum.asama)}>
                                        {asamaDurum.asama === 'medya'
                                          ? `ÜRETİLİYOR... (${asamaDurum.sn} sn)`
                                          : icerik.medyaHazir ? 'YENİDEN ÜRET' : 'ÜRET'}
                                      </button>
                                      {uretimBilgi && (
                                        <span style={{ fontSize: 10.5, color: 'var(--text-muted)', marginLeft: 8 }}>
                                          {icerik.medyaTuru === 'video' && (videoKaynak || icerik.videoKaynak || 'resim') === 'video'
                                            ? `${uretimBilgi.video.model} · ${uretimBilgi.video.sure} sn`
                                            : uretimBilgi.gorsel.model}
                                          {uretimBilgi.kalanKredi != null ? ` · kalan kredi: ${uretimBilgi.kalanKredi}` : ''}
                                        </span>
                                      )}
                                    </div>

                                    {/* 2. AŞAMA — SESLENDİRME (yalnızca video reklamında) */}
                                    {icerik.sesGerekli && (
                                      <div style={asamaKutu(icerik.sesHazir)}>
                                        <div style={asamaBaslik}>
                                          <span>2 · Seslendirme</span>
                                          {icerik.sesHazir && <span style={rozet}>✓ {icerik.sesSaniye} sn</span>}
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 7, flexWrap: 'wrap' }}>
                                          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Ses:</span>
                                          <select value={seciliSes || icerik.parcalar?.seslendirme?.ses || ''}
                                            onChange={e2 => setSeciliSes(e2.target.value)}
                                            style={{
                                              padding: '5px 8px', fontSize: 12, borderRadius: 5,
                                              border: '1px solid var(--border)', minWidth: 200,
                                            }}>
                                            {sesler.length === 0 && <option value="">— ses tanımlı değil —</option>}
                                            {sesler.map(v => (
                                              <option key={v.id} value={v.ad}>{v.ad}{v.etiket ? ` — ${v.etiket}` : ''}</option>
                                            ))}
                                          </select>
                                          {icerik.parcalar?.seslendirme?.sesGerekce && (
                                            <span style={{ fontSize: 10.5, color: 'var(--text-muted)' }}>
                                              öneri: {icerik.parcalar.seslendirme.sesGerekce}
                                            </span>
                                          )}
                                        </div>

                                        {icerik.sesHazir && (
                                          <audio controls preload="none"
                                            src={tazeAdres(`/icerik/${icerik.id}/medya/ses/seslendirme.mp3`, icerik.guncellemeZamani)}
                                            style={{ display: 'block', width: '100%', maxWidth: 320, marginBottom: 7 }} />
                                        )}

                                        <button disabled={!!asamaDurum.asama} onClick={() => asamaCalistir('ses')}
                                          style={asamaDugmesi(icerik.sesHazir, !!asamaDurum.asama)}>
                                          {asamaDurum.asama === 'ses'
                                            ? `ÜRETİLİYOR... (${asamaDurum.sn} sn)`
                                            : icerik.sesHazir ? 'YENİDEN ÜRET' : 'ÜRET'}
                                        </button>
                                      </div>
                                    )}

                                    {/* 3. AŞAMA — FİNAL (Creatomate). Önceki aşamalar bitmeden açılmaz. */}
                                    {(() => {
                                      const acik = icerik.medyaHazir && (!icerik.sesGerekli || icerik.sesHazir);
                                      return (
                                        <div style={{ ...asamaKutu(icerik.finalHazir), opacity: acik ? 1 : 0.55 }}>
                                          <div style={asamaBaslik}>
                                            <span>{icerik.sesGerekli ? '3' : '2'} · Final</span>
                                            {icerik.finalHazir && <span style={rozet}>✓ hazır</span>}
                                          </div>

                                          {!acik ? (
                                            <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                                              Önce {icerik.medyaHazir ? 'seslendirmeyi' : (icerik.medyaTuru === 'video' ? 'videoyu' : 'görseli')} üretin.
                                            </div>
                                          ) : (
                                            <>
                                              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 7, flexWrap: 'wrap' }}>
                                                <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Şablon:</span>
                                                <select value={seciliSablon} onChange={e2 => setSeciliSablon(e2.target.value)}
                                                  style={{
                                                    padding: '5px 8px', fontSize: 12, borderRadius: 5,
                                                    border: '1px solid var(--border)', minWidth: 240,
                                                  }}>
                                                  <option value="">Otomatik — sistem seçsin ({sablonlar.length} uygun şablon)</option>
                                                  {sablonlar.map(s2 => (
                                                    <option key={s2.sablonId} value={s2.sablonId}>{s2.ad}</option>
                                                  ))}
                                                </select>
                                              </div>

                                              <button disabled={!!asamaDurum.asama} onClick={() => asamaCalistir('final')}
                                                style={asamaDugmesi(icerik.finalHazir, !!asamaDurum.asama)}>
                                                {asamaDurum.asama === 'final'
                                                  ? `ÜRETİLİYOR... (${asamaDurum.sn} sn)`
                                                  : icerik.finalHazir ? 'YENİDEN ÜRET' : 'FİNALİ ÜRET'}
                                              </button>
                                            </>
                                          )}
                                        </div>
                                      );
                                    })()}
                                  </>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    {secili.detay && !detayCoz(secili.detay) && (
                      <div style={{ whiteSpace: 'pre-wrap', marginBottom: 14 }}>{secili.detay}</div>
                    )}

                    {/* KARARLAR'dan gelen iş emri: bu işin NEDEN açıldığını burada görürsün.
                        Kreatifi yazmadan önce okunması gereken şey bu — hangi sorunu
                        çözmesi bekleniyor, eldeki ölçüm ne diyor. */}
                    {(() => {
                      const k = detayCoz(secili.detay);
                      if (!k) return null;
                      return (
                        <div style={{ border: '1px solid #D8CCA8', background: '#FDFBF4',
                                      borderRadius: 8, padding: 14, marginBottom: 14 }}>
                          <div style={{ fontSize: 12, fontWeight: 700, color: '#8A7536',
                                        letterSpacing: '.04em', marginBottom: 6 }}>
                            BU İŞ NEDEN AÇILDI — KARARLAR ekranından geldi
                          </div>
                          {k.Baslik && (
                            <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 6 }}>{k.Baslik}</div>
                          )}
                          {k.Ozet && (
                            <div style={{ marginBottom: 10, lineHeight: 1.5 }}>{k.Ozet}</div>
                          )}
                          {Array.isArray(k.Kanit) && k.Kanit.length > 0 && (
                            <>
                              <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Kanıt</div>
                              <ul style={{ margin: '0 0 10px', paddingLeft: 18, lineHeight: 1.6 }}>
                                {k.Kanit.map((s, i) => <li key={i}>{s}</li>)}
                              </ul>
                            </>
                          )}
                          {k.Oneri && (
                            <div style={{ background: '#fff', border: '1px solid var(--border)',
                                          borderRadius: 6, padding: 10, marginBottom: 10 }}>
                              <span style={{ fontSize: 12, fontWeight: 700, color: '#2E7D4F',
                                             marginRight: 6 }}>ÖNERİM</span>
                              {k.Oneri}
                            </div>
                          )}
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 24px', fontSize: 13 }}>
                            {k.Yaparsak && <div><b style={{ color: '#6B6B6B' }}>Yaparsak</b> {k.Yaparsak}</div>}
                            {k.Yapmazsak && <div><b style={{ color: '#6B6B6B' }}>Yapmazsak</b> {k.Yapmazsak}</div>}
                          </div>
                        </div>
                      );
                    })()}

                    {/* Yeni reklam içeriği: teslim/geri alma kanalı */}
                    {secili.kararTuru === 'YeniReklamIcerigi' && (
                      <div style={{ border: '1px solid #9FC3E3', background: '#F5F9FD', borderRadius: 8, padding: 14 }}>
                        <div style={{ fontWeight: 600, marginBottom: 8 }}>İçerik teslimi</div>
                        {secili.oneriGorselUrl && (
                          <div style={{ marginBottom: 10 }}>
                            <img src={secili.oneriGorselUrl} alt="öneri görseli"
                                 style={{ maxWidth: '100%', borderRadius: 6, border: '1px solid var(--border)' }} />
                          </div>
                        )}
                        {secili.gorselUstuMetin && (
                          <div style={{ marginBottom: 10 }}>
                            <div style={{ fontSize: 12, fontWeight: 600 }}>Görsel üstü metinler</div>
                            <div style={{ whiteSpace: 'pre-wrap' }}>{secili.gorselUstuMetin}</div>
                          </div>
                        )}
                        {secili.anaMetin && (
                          <div style={{ marginBottom: 10 }}>
                            <div style={{ fontSize: 12, fontWeight: 600 }}>Ana metin (gönderi metni)</div>
                            <div style={{ whiteSpace: 'pre-wrap' }}>{secili.anaMetin}</div>
                          </div>
                        )}
                        {secili.baslik && (
                          <div style={{ marginBottom: 10 }}>
                            <div style={{ fontSize: 12, fontWeight: 600 }}>Başlık (görselin altındaki satır)</div>
                            {secili.baslik}
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div style={{ padding: '12px 20px', borderTop: '1px solid var(--border)', display: 'flex', gap: 10, justifyContent: 'flex-end', alignItems: 'center', flexWrap: 'wrap' }}>
                    {/* Bu dugmelerin iceriKle degil ONERIYLE ilgili oldugunu soyle (2026-08-22). */}
                    {secili.durum === 'Bekliyor' && (
                      <span style={{ fontSize: 11, color: 'var(--text-muted)', marginRight: 'auto' }}>
                        {secili.kararTuru === 'YeniOlustur' || secili.kararTuru === 'YeniReklamIcerigi'
                          ? <>İçeriği yukarıdan üretip <strong>YAYINLA</strong> derseniz iş emri kendiliğinden kapanır. <strong>Reddet</strong> ise üretmeden kapatır.</>
                          : <>Bu düğmeler <strong>iş emrini</strong> yanıtlar. Uygulama ayrı adımdır.</>}
                      </span>
                    )}
                    {secili.durum === 'Bekliyor' && secili.kararTuru === 'GozdenGecir' && (
                      <>
                        <button onClick={() => gozdenEylem(secili.id, 'goruldu')} disabled={islemde}
                          title="Listeden düşer. Sorun sürüyorsa haftalık tarama yeniden getirir."
                          style={{
                            background: '#fff', color: '#5A6B78', border: '1px solid var(--border)', borderRadius: 6,
                            padding: '8px 14px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer',
                          }}>Görüldü, izlemeye devam</button>
                        <button onClick={() => gozdenEylem(secili.id, 'yenile')} disabled={islemde}
                          title="Yeni Reklam İçeriği sekmesine taşınır."
                          style={{
                            background: '#fff', color: '#1F6FB2', border: '1px solid #1F6FB2', borderRadius: 6,
                            padding: '8px 14px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer',
                          }}>Yenileme kararı</button>
                        <button onClick={() => gozdenEylem(secili.id, 'pasife')} disabled={islemde}
                          title="Pasife Al sekmesine taşınır."
                          style={{
                            background: '#fff', color: '#C0392B', border: '1px solid #C0392B', borderRadius: 6,
                            padding: '8px 14px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer',
                          }}>Pasife alma kararı</button>
                      </>
                    )}
                    {secili.durum === 'Bekliyor' && secili.kararTuru !== 'GozdenGecir' && (
                      <>
                        {/* REDDET ONAY SORAR (2026-08-22): tek tıkla iş emri kapanıyordu,
                            kullanıcı haklı olarak soru bekliyordu. */}
                        <button onClick={() => {
                          const uretildi = icerik && (icerik.uretilen?.gorsel || icerik.uretilen?.video || icerik.finalBaglanti);
                          if (!window.confirm(
                            'Bu öneri reddedilsin mi?' +
                            (uretildi ? '\n\nÜretilmiş içerik silinmez, dosyalar durur; yalnızca iş emri kapanır.' : '') +
                            '\n\nMeta\'da hiçbir değişiklik yapılmaz.'
                          )) return;
                          kararVer(secili.id, false);
                        }} disabled={islemde} style={{
                          background: '#fff', color: '#C0392B', border: '1px solid #C0392B', borderRadius: 6,
                          padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                        }}>Reddet</button>
                        {/* KABUL ET yalnızca Meta'ya yazılacak kararlarda var (kullanıcı
                            mantığı: 2026-08-25). İçerik üretilen türlerde kabul etmek hiçbir
                            şey yapmıyordu — ya üretirsiniz, ya reddedersiniz, ya da iş emri
                            listede bekler. */}
                        {secili.kararTuru !== 'YeniOlustur' && secili.kararTuru !== 'YeniReklamIcerigi' && (
                          <button title="Yalnızca iş emrini kabul eder; uygulama ayrı adımdır"
                            onClick={() => kararVer(secili.id, true)} disabled={islemde} style={{
                              background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 6,
                              padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                            }}>Kabul Et</button>
                        )}
                      </>
                    )}
                    {secili.durum !== 'Bekliyor' && (
                      <span style={{
                        fontSize: 12, alignSelf: 'center', fontWeight: secili.uygulanmaZamani ? 700 : 400,
                        color: secili.uygulanmaZamani ? '#1D7A56' : 'var(--text-muted)',
                      }}>
                        {secili.uygulanmaZamani
                          ? `✓ Yayına alındı — ${tarihFormat(secili.uygulanmaZamani)}`
                          : `Durum: ${secili.durum} · ${tarihFormat(secili.onayZamani)}`}
                      </span>
                    )}

                    {/* VAZGEÇ — kabul edilmiş ama Meta'ya HENÜZ yazılmamış karar için
                        (kullanıcı: "kabul etmiştim ama vazgeçtim, burada kilitlendi kaldı").
                        Uygulanmış kararın yolu farklı: orada "geri al" var. */}
                    {secili.durum === 'Onaylandi' && !secili.uygulanmaZamani && (
                      <button onClick={() => {
                        if (!window.confirm('Bu karardan vazgeçilsin mi? Meta\'ya hiçbir şey yazılmadı, kayıt "Reddedildi" olur.')) return;
                        kararVer(secili.id, false);
                      }} disabled={islemde} style={{
                        background: '#fff', color: '#C0392B', border: '1px solid #C0392B', borderRadius: 6,
                        padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                      }}>Vazgeç</button>
                    )}
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}

      {/* PERFORMANS RAPORU (kullanıcı talebi: 2026-08-31): "yayına alındığından bugüne kaç
          lead, kaç randevu, kaç lira ciro". Meta rakamları üstte, klinik gerçeği altta;
          en sonda tek cümlelik hüküm. Ciro Meta'dan gelmez — lead'in telefonu şube
          veritabanlarında aranıp gerçekten gelen hastanın işlemleri toplanır. */}
      {rapor && (
        <div onClick={() => setRapor(null)} style={{
          position: 'fixed', inset: 0, background: 'rgba(20,30,28,0.45)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, zIndex: 1000,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 10, width: 'min(720px, 100%)',
            maxHeight: '90vh', overflow: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
          }}>
            <div style={{
              padding: '14px 20px', borderBottom: '1px solid var(--border)',
              display: 'flex', alignItems: 'center', gap: 10,
            }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 700 }}>📊 Reklam Karnesi</div>
                <div style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>
                  {rapor.kampanya}{rapor.set ? ` · ${rapor.set}` : ''} ·
                  {' '}{new Date(rapor.donem.baslangic).toLocaleDateString('tr-TR')} –
                  {' '}{new Date(rapor.donem.bitis).toLocaleDateString('tr-TR')} ({rapor.donem.gun} gün)
                </div>
              </div>
              <button onClick={() => setRapor(null)} style={{
                background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--text-muted)',
              }}>×</button>
            </div>

            <div style={{ padding: 20 }}>
              {/* Tek cümlelik hüküm — rakamlara girmeden önce cevap */}
              <div style={{
                padding: '11px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13, fontWeight: 600,
                background: rapor.kazanc.fark > 0 ? '#EAF6F0' : rapor.sonuc.lead === 0 ? '#F2F4F7' : '#FFF6E5',
                color: rapor.kazanc.fark > 0 ? '#1D7A56' : rapor.sonuc.lead === 0 ? '#5A6B78' : '#8A6D1F',
                border: `1px solid ${rapor.kazanc.fark > 0 ? '#9FD3BB' : rapor.sonuc.lead === 0 ? 'var(--border)' : '#E8C468'}`,
              }}>{rapor.kazanc.yorum}</div>

              <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.4px', marginBottom: 7 }}>
                Reklam tarafı — Meta
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(105px, 1fr))', gap: 10, marginBottom: 18 }}>
                {[
                  { ad: 'Harcama', d: `${(rapor.reklam.harcama || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺` },
                  { ad: 'Günlük', d: `${(rapor.reklam.gunlukHarcama || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 })} ₺` },
                  { ad: 'Gösterim', d: (rapor.reklam.gosterim || 0).toLocaleString('tr-TR') },
                  { ad: 'Tık', d: (rapor.reklam.tik || 0).toLocaleString('tr-TR') },
                  { ad: 'CTR', d: `%${(rapor.reklam.ctr || 0).toLocaleString('tr-TR')}` },
                  { ad: 'Tık başı', d: rapor.reklam.tikBasi != null ? `${rapor.reklam.tikBasi.toLocaleString('tr-TR', { maximumFractionDigits: 2 })} ₺` : '—' },
                ].map(x => (
                  <div key={x.ad} style={{ border: '1px solid var(--border)', borderRadius: 7, padding: '8px 10px' }}>
                    <div style={{ fontSize: 10, color: 'var(--text-muted)', textTransform: 'uppercase' }}>{x.ad}</div>
                    <div style={{ fontSize: 14, fontWeight: 700 }}>{x.d}</div>
                  </div>
                ))}
              </div>

              <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.4px', marginBottom: 7 }}>
                Sonuç tarafı — klinik
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(105px, 1fr))', gap: 10, marginBottom: 12 }}>
                {[
                  { ad: 'Lead', d: rapor.sonuc.lead, vurgu: true },
                  { ad: 'Randevu', d: rapor.sonuc.randevuVerildi, alt: rapor.sonuc.randevuOrani != null ? `%${rapor.sonuc.randevuOrani}` : null },
                  { ad: 'Gelen hasta', d: rapor.sonuc.gelenHasta, alt: rapor.sonuc.gelmeOrani != null ? `%${rapor.sonuc.gelmeOrani}` : null },
                  { ad: 'Ciro', d: `${(rapor.sonuc.ciro || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 })} ₺`, vurgu: true },
                  { ad: 'Net katkı', d: `${(rapor.sonuc.netKatki || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 })} ₺`, alt: 'maliyet düşülmüş' },
                  { ad: 'Lead başı', d: rapor.sonuc.leadBasiMaliyet != null ? `${rapor.sonuc.leadBasiMaliyet.toLocaleString('tr-TR', { maximumFractionDigits: 0 })} ₺` : '—' },
                ].map(x => (
                  <div key={x.ad} style={{ border: '1px solid var(--border)', borderRadius: 7, padding: '8px 10px' }}>
                    <div style={{ fontSize: 10, color: 'var(--text-muted)', textTransform: 'uppercase' }}>{x.ad}</div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: x.vurgu ? '#1D7A56' : 'var(--text)' }}>{x.d}</div>
                    {x.alt && <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>{x.alt}</div>}
                  </div>
                ))}
              </div>

              {/* Harcanan para geri geldi mi — tek satır */}
              <div style={{
                display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center',
                padding: '10px 14px', borderRadius: 8, background: '#F7F9FA', border: '1px solid var(--border)',
                marginBottom: 12,
              }}>
                <div style={{ fontSize: 12 }}>Net katkı − harcama:{' '}
                  <strong style={{ color: rapor.kazanc.fark >= 0 ? '#1D7A56' : '#C0392B', fontSize: 14 }}>
                    {(rapor.kazanc.fark || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 })} ₺
                  </strong>
                </div>
                {rapor.kazanc.katsayi != null && (
                  <div style={{ fontSize: 12 }}>Her 1 ₺ harcamaya karşılık:{' '}
                    <strong style={{ fontSize: 14 }}>{rapor.kazanc.katsayi.toLocaleString('tr-TR')} ₺</strong> net katkı
                  </div>
                )}
              </div>

              <div style={{ fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.6 }}>
                Durum: {rapor.durum.aciklama}
                {rapor.sonuc.lead > 0 && (
                  <> · Lead’ler ortalama {rapor.sonuc.ortalamaLeadYasiGun} günlük — yeni lead’lerin
                  kliniğe gelmesi haftalar alabilir, ciro sonradan artabilir.</>
                )}
                {rapor.sonuc.maliyetiBilinmeyenCiro > 0 && (
                  <> · {rapor.sonuc.maliyetiBilinmeyenCiro.toLocaleString('tr-TR', { maximumFractionDigits: 0 })} ₺ cironun
                  maliyet oranı girilmediği için net katkıya dahil edilmedi.</>
                )}
              </div>

              {rapor.uyari && (
                <div style={{ marginTop: 10, fontSize: 11.5, color: '#8A6D1F', background: '#FFF6E5', border: '1px solid #E8C468', borderRadius: 6, padding: '8px 11px' }}>
                  ⚠ {rapor.uyari}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
